/* DYOCHAIN Konfigurator – JavaScript (aus sections/dyochain-drag-drop-konfigurator.liquid ausgelagert, damit die Section unter Shopifys 256-KB-Limit bleibt).
   Wird per <script src="{{ 'dyochain-konfigurator.js' | asset_url }}" data-dyo-section-id="{{ section.id }}"> von der Section geladen.
   Teil 1: gemeinsame Engine (identisch zu dyochain-api/lib/dyoEngine.js, per scripts/sync-engine.js synchronisiert). Teil 2: Konfigurator. */
/* DYO-ENGINE-SYNC:BEGIN */
/* DYO-ENGINE:BEGIN (Quelle: dyochain-api/lib/dyoEngine.js, per scripts/sync-engine.js in die Liquid-Datei kopiert) */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.DyoEngine = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  const BEAD_MM = 6;
  const CLOSURE_MM = 4;
  // ---------------------------------------------------------------------------------------------------------------------
  // Armbandgroessen: EINE zentrale Zuordnung. Der technische Schluessel ist NICHT die sichtbare Bezeichnung, sondern eine stabile
  // interne ID (G<Plaetze>). So kann sich die Beschriftung aendern, ohne dass aeltere Designs, Warenkoerbe oder Bestellungen mit einer
  // falschen Slot-Anzahl gelesen werden. Die Plaetze sind die regulaer belegbaren Plaetze; die Verschlussperle liegt zusaetzlich
  // ausserhalb davon (physisch also 26/28/30/32/34/36 Positionen) und zaehlt weder als Platz noch als Stein oder Spacer.
  // ---------------------------------------------------------------------------------------------------------------------
  // Schema 4 (ab 2026-10-27): aktuelle Auswahl, aufsteigend: XS 25 · S 27 · M 29 · L 31 · XL 33 · XXL 35 Natursteinplaetze, plus je eine separate Verschlussperle.
  // ACHTUNG G29: Der Schluessel "G29" gehoert dauerhaft dem frueheren L (ca. 19 cm, Schema 2, RETIRED_SIZES). Das neue M mit 29 Plaetzen und ca. 18 cm hat
  // deshalb einen EIGENEN Schluessel ("G29M", 4 Zeichen = Spaltenbreite designs.size VARCHAR(4)). Kein Schluessel hat je zwei Bedeutungen; die Zuordnung
  // Schluessel -> Platzanzahl/Bezeichnung/Umfang ist ohne sizeScheme eindeutig lesbar (auch fuer alte Datensaetze ohne sizeScheme).
  const SIZES = [
    { key: 'G25', label: 'XS', cm: 16, slots: 25 },
    { key: 'G27', label: 'S', cm: 17, slots: 27 },
    { key: 'G29M', label: 'M', cm: 18, slots: 29 },
    { key: 'G31', label: 'L', cm: 19, slots: 31 },
    { key: 'G33', label: 'XL', cm: 20, slots: 33 },
    { key: 'G35', label: 'XXL', cm: 21, slots: 35 }
  ];
  // Ausgelaufene Schluessel: nicht mehr waehlbar, aber gueltig und lesbar (aeltere Designs, Warenkoerbe, zwischengespeicherte Seiten) mit ihrer damaligen
  // Platzanzahl und Bezeichnung. Es gibt keine stille Umwandlung auf eine neue Groesse und keine Kapazitaets-Neuberechnung: die Regeln (Staffeln,
  // "Zwischen allen"-Tabellen je Platzanzahl) haengen nur an der Platzanzahl und sind unveraendert.
  //   G24 (XS, 24 Plaetze), G26 (S, 26 Plaetze), G28 (M, 28 Plaetze, ca. 18 cm): bis 2026-10-26, Schema 3.   G29 (L, 29 Plaetze, ca. 19 cm): bis 2026-10-24, Schema 2.
  // G31 und G33 behalten ihre Platzanzahl (31/33); ihre damalige Bezeichnung (XL/XXL) steht in den Snapshots bereits angelegter Designs (sizeText).
  const RETIRED_SIZES = {
    G24: { label: 'XS', cm: 16, slots: 24, scheme: 3 },
    G26: { label: 'S', cm: 17, slots: 26, scheme: 3 },
    G28: { label: 'M', cm: 18, slots: 28, scheme: 3 },
    G29: { label: 'L', cm: 19, slots: 29, scheme: 2 }
  };
  // Schema 1 (bis 2026-10-17): fruehere technische Schluessel. Sie bleiben gueltig, damit aeltere Designs, Warenkoerbe und Bestellungen
  // unveraendert (mit ihrer damaligen Bezeichnung und Slot-Anzahl) gelesen werden. Neue Konfigurationen verwenden sie nicht mehr.
  const LEGACY_SIZES = {
    XS: { label: 'XS', cm: 15, slots: 26 },
    S: { label: 'S', cm: 16, slots: 28 },
    M: { label: 'M', cm: 17, slots: 29 },
    L: { label: 'L', cm: 18, slots: 31 },
    XL: { label: 'XL', cm: 19, slots: 33 }
  };
  const DEFAULT_SIZE_KEY = 'G29M'; // Vorauswahl bei neuen Konfigurationen: M (ca. 18 cm), seit 2026-10-27 mit 29 Natursteinplaetzen
  const BASE_SLOTS = {};
  SIZES.forEach(z => { BASE_SLOTS[z.key] = z.slots; });
  Object.keys(LEGACY_SIZES).forEach(k => { BASE_SLOTS[k] = LEGACY_SIZES[k].slots; });
  Object.keys(RETIRED_SIZES).forEach(k => { BASE_SLOTS[k] = RETIRED_SIZES[k].slots; });
  const CLOSURE_LEFT = 'closure-left';
  const CLOSURE_RIGHT = 'closure-right';
  const CLOSURES = {
    silver: { id: 'silver', label: 'Silber', material: '925er Silber', cartLabel: '925er Silber 4 mm' }, // Material vom Inhaber bestaetigt (Lieferant weist 925er Silber aus); frueher "304 Edelstahl"
    gold: { id: 'gold', label: 'Gold', material: '14K Gold PVD', cartLabel: 'Gold · 14K Gold PVD · 4 mm' }
  };

  const cents = v => Math.round(Number(v || 0) * 100);
  const fromCents = c => c / 100;
  const euro = c => (c / 100).toFixed(2).replace('.', ',') + ' €';

  function baseSlotCount(size) { return BASE_SLOTS[size] || BASE_SLOTS.G29; } // unbekannter Schluessel: wie bisher 29 (validate meldet SIZE_UNKNOWN)

  // Beschreibung zu einem technischen Schluessel (aktuell oder frueher). Unbekannt -> null.
  function sizeInfo(key) {
    const cur = SIZES.find(z => z.key === key);
    if (cur) return { key: cur.key, label: cur.label, cm: cur.cm, slots: cur.slots, legacy: false, circumference: 'ca. ' + cur.cm + ' cm', text: cur.label + ' (ca. ' + cur.cm + ' cm)' };
    const gone = Object.prototype.hasOwnProperty.call(RETIRED_SIZES, key) ? RETIRED_SIZES[key] : null;
    if (gone) return { key, label: gone.label, cm: gone.cm, slots: gone.slots, legacy: false, retired: true, scheme: gone.scheme, circumference: 'ca. ' + gone.cm + ' cm', text: gone.label + ' (ca. ' + gone.cm + ' cm)' };
    const old = Object.prototype.hasOwnProperty.call(LEGACY_SIZES, key) ? LEGACY_SIZES[key] : null;
    if (old) return { key, label: old.label, cm: old.cm, slots: old.slots, legacy: true, circumference: 'ca. ' + old.cm + ' cm', text: old.label + ' (ca. ' + old.cm + ' cm)' };
    return null;
  }
  // Sichtbarer Text, z. B. "M (ca. 18 cm)"; fuer aeltere Schluessel mit der damaligen Bezeichnung. Unbekannt -> der Rohwert.
  function sizeText(key) { const i = sizeInfo(key); return i ? i.text : String(key || ''); }
  // Schluessel fuer die Wiederherstellung aelterer Designs/Warenkoerbe. Es gibt KEINE stille Umdeutung: jeder gueltige Schluessel (aktuell,
  // ausgelaufen G24/G26/G28/G29 oder frueher XS/S/M/L/XL) bleibt bei sich und behaelt Bezeichnung, Umfang und Platzanzahl von damals.
  // Beispiel: frueheres "M" (ca. 17 cm, 29 Plaetze) wird NICHT zum heutigen M (G29M, ca. 18 cm), und G29 = L ca. 19 cm wird nie zum neuen M
  // mit ebenfalls 29 Plaetzen. Unbekannt -> null. (Bis 2026-10-27 wurden XS/S/M/L/XL beim Laden auf die heutige Groesse mit gleicher Platzanzahl
  // umgeschluesselt; das ist nicht mehr der Fall.)
  function currentSizeKey(key) {
    const i = sizeInfo(key);
    return i ? i.key : null;
  }

  // Prueft beim Wiederherstellen, ob Schluessel und gespeicherte Belegung zusammenpassen, damit nichts stillschweigend umgedeutet wird.
  //   meta.slotCount   : im Snapshot festgeschriebene Platzanzahl (nur Designs ab 2026-10-19; Quelle der Wahrheit)
  //   meta.slotsLength : Laenge der gespeicherten Platzliste (Altdaten ohne slotCount: der aeltere Client haelt sie konstant auf der Grundplatzzahl)
  // Ergebnis: { ok, key, info, reason?, expected?, stored? }. reason: SIZE_UNKNOWN | SLOTCOUNT_MISMATCH | SLOTS_LENGTH_MISMATCH.
  // Bei ok=false darf der Aufrufer NICHT wiederherstellen (kein Abschneiden, kein Auffuellen, keine andere Groesse).
  // Hintergrund: der Schluessel "M" hatte vor 2026-10-17 30 Plaetze (BASE_SLOTS XS27/S29/M30/L32/XL34), danach 29; Designs aus der ersten Zeit
  // tragen weder sizeText noch slotCount und sind nur ueber die gespeicherte Platzliste eindeutig.
  function restoreSizeInfo(key, meta) {
    const info = sizeInfo(key);
    if (!info) return { ok: false, key: null, info: null, reason: 'SIZE_UNKNOWN' };
    const m = meta || {};
    if (Number.isInteger(m.slotCount)) {
      if (m.slotCount !== info.slots) return { ok: false, key: info.key, info, reason: 'SLOTCOUNT_MISMATCH', expected: info.slots, stored: m.slotCount };
      return { ok: true, key: info.key, info };
    }
    if (Number.isInteger(m.slotsLength) && m.slotsLength !== info.slots) return { ok: false, key: info.key, info, reason: 'SLOTS_LENGTH_MISMATCH', expected: info.slots, stored: m.slotsLength };
    return { ok: true, key: info.key, info };
  }

  // Sichtbare Umfangsangabe je Armbandgroesse (ersetzt die frueheren Bereichsangaben aus dem Katalog).
  function sizeCircumferenceLabel(size) { const i = sizeInfo(size); return i ? i.circumference : null; }

  // Regel "thickness-v2" (aktueller Stand im Konfigurator, unveraendert uebernommen):
  // Kapazitaet haengt von der realen Spacer-Dicke ab, Ergebnis wird abgerundet (floor).
  function computeStoneCapacity(baseSlots, thicknessMm, gapCount, mode) {
    if (!thicknessMm || mode === 'none') return baseSlots;
    const available = baseSlots * BEAD_MM;
    if (mode === 'all') {
      const n = Math.floor((available - thicknessMm) / (BEAD_MM + thicknessMm));
      return Math.max(0, Math.min(baseSlots, n));
    }
    if (mode === 'manual') {
      const n = Math.floor((available - gapCount * thicknessMm) / BEAD_MM);
      return Math.max(0, Math.min(baseSlots, n));
    }
    return baseSlots;
  }

  // ---------------------------------------------------------------------------------------------------------------------
  // Produktspezifische Spacer-Regeln. Die Zuordnung erfolgt ueber stabile Katalog-IDs (spacer.id), nicht ueber Namen.
  //   multiSize : IDs 1-3 (Silber 4/5/6 mm) und 4-6 (Gold 4/5/6 mm)
  //   single6mm : ID 7 (separater Spacer, nur 6 mm; frueher "Weissgold/Silber")
  //   rondell   : ID 8 (Rondell Silber) und 9 (Rondell vergoldet)
  // Manuell: erforderlich entfernte Natursteine in Abhaengigkeit von der Spaceranzahl (Kapazitaet = Grundplaetze - entfernte).
  // "Zwischen allen": verbindliche Tabelle der Natursteinplaetze je Groesse; Spacer = Natursteinplaetze + 1.
  // Die Tabellen weichen bewusst von der manuellen Formel ab und werden NICHT daraus angenaehert.
  // ---------------------------------------------------------------------------------------------------------------------
  // Separater 6-mm-Spacer (ID 7, "Polierte Edelstahloptik"): KALIBRIERWERTE, keine physischen Messwerte.
  //   Beobachtung am realen Referenzarmband (S, 27 Natursteine + Verschlussperle, 2026-10-27): Spacer 1 und 2 ohne entfernte Kugel, Spacer 3 -> eine Kugel
  //   entfernt, Spacer 4-6 keine weitere, Spacer 7 -> zweite Kugel, Spacer 8-9 keine weitere (Endbelegung 25 Natursteine + 9 Spacer).
  //   Dazu passt die effektive Beanspruchung: die ersten 2 Spacer kosten keinen Natursteinplatz, danach entfaellt je 4 Spacer ein Platz (0,25 Platz je Spacer).
  //   Der Verbrauch wird ueber ALLE Spacer summiert und erst dann auf ganze Plaetze umgerechnet (aufrunden der Summe, nicht je Spacer).
  //   Praktisch geprueft: 0-9 Spacer. Die Fortsetzung ab 10 Spacern (3. Kugel bei 11, danach alle 4 Spacer) folgt derselben Periode 4 und der frueheren
  //   Staffelvorgabe (Schwellen 3/7/11/15/19/23), ist aber NICHT praktisch nachgestellt.
  const SINGLE6_FREE_SPACERS = 2;
  const SINGLE6_SPACERS_PER_STONE = 4;
  function requiredRemovedStonesForSingle6mmSpacer(spacerCount) {
    if (spacerCount <= SINGLE6_FREE_SPACERS) return 0;
    return Math.ceil((spacerCount - SINGLE6_FREE_SPACERS) / SINGLE6_SPACERS_PER_STONE);
  }

  function requiredRemovedStonesForRondell(rondellCount) {
    if (rondellCount <= 0) return 0;
    return Math.ceil((rondellCount * 4) / 9);
  }

  function requiredRemovedStonesForMultiSizeSpacer(spacerCount) {
    if (spacerCount <= 3) return 0;
    if (spacerCount <= 8) return 1;
    if (spacerCount <= 13) return 2;
    return 3 + Math.floor((spacerCount - 14) / 4);
  }

  const SPACER_RULES = {
    multiSize: { label: 'Spacer 4/5/6 mm (Silber und Gold)', ids: [1, 2, 3, 4, 5, 6], removedFor: requiredRemovedStonesForMultiSizeSpacer, allStones: { 26: 20, 28: 22, 29: 23, 31: 24, 33: 26 } },
    single6mm: { label: 'Separater 6-mm-Spacer (ID 7)', ids: [7], removedFor: requiredRemovedStonesForSingle6mmSpacer, allStones: { 26: 20, 28: 21, 29: 22, 31: 23, 33: 25 } },
    rondell: { label: 'Rondelle (Silber und vergoldet)', ids: [8, 9], removedFor: requiredRemovedStonesForRondell, allStones: { 26: 17, 28: 18, 29: 19, 31: 20, 33: 22 } }
  };

  function spacerRule(spacer) {
    const id = Number(spacer && spacer.id);
    if (!Number.isFinite(id)) return null;
    const key = Object.keys(SPACER_RULES).find(k => SPACER_RULES[k].ids.includes(id));
    return key ? SPACER_RULES[key] : null;
  }

  // Sichtbare Bezeichnung nach Katalog-ID. Gilt nur fuer den separaten 6-mm-Spacer (ID 7); ID, Preis, Aufpreis, Bild und alle anderen Eigenschaften bleiben unberuehrt.
  // Kachel wie bei den anderen Spacern: Name "Spacer ..." (die Groesse steht im Groessenbutton bzw. in Klammern), Materialzeile darunter.
  // Das Grundmaterial ist nicht zweifelsfrei bestaetigt: ausdruecklich als Optik formuliert ("Polierte Edelstahloptik"), nie als Edelstahl.
  // name:       Katalogname fuer Kachel und Uebersicht ("2 Spacer in polierter Edelstahloptik (6 mm)")
  // material:   Materialzeile der Kachel
  // fixedLabel: vollstaendige Bezeichnung fuer Komponentenliste, Anordnung und Fertigung ("Spacer – Polierte Edelstahloptik – 6 mm")
  const SPACER_DISPLAY = {
    7: { name: 'Spacer in polierter Edelstahloptik 6 mm', material: 'Polierte Edelstahloptik', fixedLabel: 'Spacer – Polierte Edelstahloptik – 6 mm' }
  };

  function spacerFixedLabel(spacerOrId) {
    const id = spacerOrId && typeof spacerOrId === 'object' ? spacerOrId.id : spacerOrId;
    const d = SPACER_DISPLAY[Number(id)];
    return d && d.fixedLabel ? d.fixedLabel : null;
  }

  // Liefert den Spacer mit der sichtbaren Bezeichnung (Kopie). Nur die sichtbaren Felder name und material werden ersetzt; id, Preise, Bilder, Masse
  // UND das interne Feld farbe (steuert nur Ersatz-Farbverlaeufe, wird nirgends angezeigt) bleiben unveraendert.
  function applySpacerDisplay(spacer) {
    const d = spacer && SPACER_DISPLAY[Number(spacer.id)];
    return d ? { ...spacer, name: d.name, material: d.material } : spacer;
  }

  function spacerThickness(cfg) { return cfg.spacer ? Number(cfg.spacer.dicke_mm) || 0 : 0; }

  function normalizedGaps(cfg) {
    const slots = cfg.slots || [];
    const visible = visibleIndexes(slots, cfg.hidden);
    const pre = closurePreceding(visible);
    const out = [];
    (cfg.gaps || []).forEach(g => {
      const key = (pre !== null && g === pre) ? CLOSURE_RIGHT : g;
      if (!out.includes(key)) out.push(key);
    });
    return out;
  }

  // Die EINE Kapazitaetsregel (Button, Warenkorb, Server, Anzeige, Wiederherstellung).
  function capacity(cfg) {
    const base = baseSlotCount(cfg.size);
    const mode = cfg.spacerMode || 'none';
    const gapCount = mode === 'manual' ? (cfg.gaps || []).length : 0;
    const rule = mode === 'none' ? null : spacerRule(cfg.spacer);
    if (rule) {
      if (mode === 'all') return rule.allStones[base] !== undefined ? rule.allStones[base] : base;
      if (mode === 'manual') return Math.max(0, base - rule.removedFor(gapCount));
    }
    return computeStoneCapacity(base, spacerThickness(cfg), gapCount, mode);
  }

  // Ist "Zwischen allen" fuer diese Groesse und diesen Spacer definiert? Spacer ohne produktspezifische Regel (Altbestand) sind es immer.
  // Fuer 24 Plaetze gibt es bisher keine verbindliche Tabelle der produktspezifischen Spacer.
  // Zwei verschiedene Gruende, warum "Zwischen allen" fehlen kann:
  //   'blocked'       = bewusste Sperre der Groesse (XS 24/25 und XXL 35 Plaetze): bleibt gesperrt, auch wenn spaeter Tabellen existieren sollten
  //   'table_missing' = fuer die Platzanzahl liegt (noch) keine verbindliche Tabelle vor (z. B. 27); reine Konfigurationsluecke, per Eintrag in allStones behebbar
  // Die Tabellen gelten je Platzanzahl und sind empirische Werte vom Inhaber; sie lassen sich weder aus der Staffel noch aus der Dickenformel berechnen
  // (siehe docs/GROESSEN_M29_ZWISCHEN_ALLEN_2026-10-27.md).
  const ALL_MODE_BLOCKED_SLOTS = { 24: true, 25: true, 35: true };
  function allModeStatus(cfg) {
    const rule = spacerRule(cfg.spacer);
    const base = baseSlotCount(cfg.size);
    if (!rule) return 'available';
    if (ALL_MODE_BLOCKED_SLOTS[base]) return 'blocked';
    return rule.allStones[base] !== undefined ? 'available' : 'table_missing';
  }
  function allModeAvailable(cfg) { return allModeStatus(cfg) === 'available'; }
  function allModeNotice(cfg) {
    const st = allModeStatus(cfg);
    if (st === 'blocked') return 'Für diese Armbandgröße ist „Zwischen allen“ nicht vorgesehen. Wähle „Manuell“ oder „Ohne“.';
    if (st === 'table_missing') return 'Für diese Armbandgröße ist „Zwischen allen“ mit diesem Spacer noch nicht freigegeben (verbindliche Tabelle fehlt). Wähle „Manuell“ oder „Ohne“.';
    return null;
  }

  // Wie viele Natursteine muessen fuer diesen Zustand mindestens entfernt sein (gegenueber den Grundplaetzen)?
  function removedStonesRequired(cfg) { return Math.max(0, baseSlotCount(cfg.size) - capacity(cfg)); }

  function spacerCount(cfg) {
    if (!cfg.spacer) return 0;
    if (cfg.spacerMode === 'manual') return (cfg.gaps || []).length;
    if (cfg.spacerMode === 'all') { const c = capacity(cfg); return c > 0 ? c + 1 : 0; }
    return 0;
  }

  function filledCount(cfg) { return (cfg.slots || []).filter(Boolean).length; }

  function visibleIndexes(slots, hidden) {
    const hide = new Set();
    let n = Math.max(0, Number(hidden) || 0);
    for (let i = slots.length - 1; i >= 0 && n > 0; i--) { if (!slots[i]) { hide.add(i); n--; } }
    const out = [];
    for (let i = 0; i < slots.length; i++) if (!hide.has(i)) out.push(i);
    return out;
  }

  function closurePreceding(visible) { return visible.length ? visible[Math.ceil(visible.length / 2) - 1] : null; }

  // Preis in ganzen Cent (keine Gleitkomma-Summen).
  function pricing(cfg, basisPreis) {
    const baseCents = cents(basisPreis);
    const stonesCents = (cfg.slots || []).reduce((s, it) => s + (it ? cents(it.aufpreis) : 0), 0);
    const spacerEach = cfg.spacer ? cents(cfg.spacer.aufpreis) : 0;
    const spacerCents = spacerCount(cfg) * spacerEach;
    return { baseCents, stonesCents, spacerCents, extrasCents: stonesCents + spacerCents, totalCents: baseCents + stonesCents + spacerCents };
  }

  // Eine Regel fuer Button, Warenkorb-Klick und Serverpruefung.
  function validate(cfg) {
    const reasons = [];
    const slots = cfg.slots || [];
    const hidden = Math.max(0, Number(cfg.hidden) || 0);
    const cap = capacity(cfg);
    const filled = filledCount(cfg);
    const visible = visibleIndexes(slots, hidden);
    const visibleEmpty = visible.filter(i => !slots[i]).length;
    const spacers = spacerCount(cfg);

    if (!BASE_SLOTS[cfg.size]) reasons.push({ code: 'SIZE_UNKNOWN', short: 'Größe wählen', text: 'Bitte wähle eine Armbandgröße.' });
    if (!CLOSURES[cfg.closure]) reasons.push({ code: 'CLOSURE_UNKNOWN', short: 'Verschluss wählen', text: 'Bitte wähle eine Verschlussperle.' });
    if (!['none', 'manual', 'all'].includes(cfg.spacerMode || 'none')) reasons.push({ code: 'MODE_UNKNOWN', short: 'Spacer-Modus prüfen', text: 'Ungültiger Spacer-Modus.' });

    if (filled > cap) {
      const n = filled - cap;
      reasons.push({ code: 'OVERFILLED', n, short: `${n} ${n === 1 ? 'Stein' : 'Steine'} zu viel`, text: `Es sind ${n} ${n === 1 ? 'Stein' : 'Steine'} zu viel für die gewählten Spacer. Entferne ${n === 1 ? 'einen Stein' : n + ' Steine'} oder reduziere die Spacer.` });
    } else if (filled < cap) {
      const n = cap - filled;
      if (visibleEmpty === 0) {
        reasons.push({ code: 'HIDDEN_CAPACITY', n, short: 'Spacer noch nicht gesetzt', text: 'Es fehlt noch ein Platz, der im Ring nicht sichtbar ist. Setze den gewählten Spacer oder mache die letzte Aktion rückgängig.' });
      } else {
        reasons.push({ code: 'SLOTS_OPEN', n, short: `Noch ${n} ${n === 1 ? 'Platz' : 'Plätze'} frei`, text: `Noch ${n} ${n === 1 ? 'Platz' : 'Plätze'} frei.` });
      }
    }

    if (cfg.spacerMode === 'all' && cfg.spacer && !allModeAvailable(cfg)) reasons.push({ code: 'ALL_MODE_UNAVAILABLE', detail: allModeStatus(cfg), short: '„Zwischen allen“ nicht verfügbar', text: allModeNotice(cfg) });
    if (cfg.spacerMode === 'all' && !cfg.spacer) reasons.push({ code: 'SPACER_MISSING', short: 'Spacer wählen', text: 'Wähle einen Spacer oder stelle den Modus auf „Ohne“.' });

    const validGapIds = new Set([CLOSURE_LEFT, CLOSURE_RIGHT, ...visible]);
    const gaps = normalizedGaps(cfg);
    if (cfg.spacerMode === 'manual') {
      if (gaps.length && !cfg.spacer) reasons.push({ code: 'SPACER_MISSING', short: 'Spacer wählen', text: 'Gesetzte Spacer haben keine Ausführung.' });
      const bad = gaps.filter(g => !validGapIds.has(g));
      if (bad.length) reasons.push({ code: 'GAP_INVALID', short: 'Spacer-Position prüfen', text: 'Eine Spacer-Position ist ungültig. Bitte prüfe die Platzierung.' });
      if (gaps.length !== (cfg.gaps || []).length) reasons.push({ code: 'GAP_DUPLICATE', short: 'Spacer-Position prüfen', text: 'Zwei Spacer liegen auf derselben Position.' });
    }

    return { orderable: reasons.length === 0, reasons, stats: { filled, capacity: cap, spacers, visibleEmpty, hidden } };
  }

  // Reihenfolge entlang des Rings, wie im Konfigurator gezeichnet (Verschluss bei 6 Uhr).
  function sequence(cfg) {
    const slots = cfg.slots || [];
    const visible = visibleIndexes(slots, cfg.hidden);
    if (!visible.length) return [];
    const pre = closurePreceding(visible);
    const gaps = cfg.spacerMode === 'manual' ? normalizedGaps(cfg) : [];
    const at = id => !!cfg.spacer && (cfg.spacerMode === 'all' || (cfg.spacerMode === 'manual' && gaps.includes(id)));
    const seq = [];
    visible.forEach(i => {
      seq.push({ type: 'stone', slotIndex: i, item: slots[i] || null });
      if (i === pre) {
        if (at(CLOSURE_RIGHT)) seq.push({ type: 'spacer', gap: CLOSURE_RIGHT, spacer: cfg.spacer });
        seq.push({ type: 'closure', finish: cfg.closure });
        if (at(CLOSURE_LEFT)) seq.push({ type: 'spacer', gap: CLOSURE_LEFT, spacer: cfg.spacer });
      } else if (at(i)) {
        seq.push({ type: 'spacer', gap: i, spacer: cfg.spacer });
      }
    });
    return seq;
  }

  function spacerKind(spacer) {
    return /rondell/i.test((spacer && spacer.name) || '') ? 'rondell' : 'spacer';
  }

  function cleanName(name) {
    return String(name || '').replace(/\s*\d+([.,]\d+)?\s*mm\s*/gi, ' ').replace(/^Premium-Kugel\b/i, 'Design-Kugel').replace(/\s+/g, ' ').replace(/^[\s,;]+|[\s,;]+$/g, '');
  }

  // Leserichtung: Start unmittelbar nach der Verschlussperle (6 Uhr), im Uhrzeigersinn, Vorderansicht.
  function readingOrder(cfg) {
    const seq = sequence(cfg);
    const ci = seq.findIndex(e => e.type === 'closure');
    const rotated = ci === -1 ? seq.slice() : seq.slice(ci + 1).concat(seq.slice(0, ci));
    const out = [];
    const closure = CLOSURES[cfg.closure] || CLOSURES.silver;
    out.push({ pos: 0, kind: 'closure', name: `Verschlussperle ${closure.label}`, detail: `${closure.material} · ${CLOSURE_MM} mm`, finish: cfg.closure, widthMm: CLOSURE_MM });
    rotated.forEach(e => {
      if (e.type === 'closure') return;
      const n = out.length;
      if (e.type === 'stone') {
        const it = e.item || {};
        const isDesign = it.contentType === 'premiumBead';
        out.push({ pos: n, kind: isDesign ? 'designBead' : 'stone', id: it.id, name: cleanName(it.name), farbe: it.farbe || null, aufpreis: Number(it.aufpreis || 0), widthMm: BEAD_MM, slotIndex: e.slotIndex, item: it });
      } else {
        const sp = e.spacer || {};
        out.push({ pos: n, kind: spacerKind(sp), id: sp.id, name: cleanName(sp.name), fixedLabel: spacerFixedLabel(sp), farbe: sp.farbe || null, aufpreis: Number(sp.aufpreis || 0), widthMm: Math.max(0.5, Number(sp.dicke_mm) || 1), diameterMm: Number(sp.aussendurchmesser_mm) || 0, gap: e.gap, spacer: sp });
      }
    });
    return out;
  }

  // Materialliste getrennt nach Natursteinen, Design-Kugeln, Zwischenelementen (Spacer/Rondelle), Verschluss.
  function materials(cfg) {
    const order = readingOrder(cfg);
    const groups = { stone: new Map(), designBead: new Map(), spacer: new Map(), rondell: new Map() };
    order.forEach(o => {
      if (o.kind === 'closure') return;
      const m = groups[o.kind];
      const key = `${o.id}|${o.name}`;
      const cur = m.get(key) || { id: o.id, name: o.name, fixedLabel: o.fixedLabel || null, count: 0, aufpreis: o.aufpreis };
      cur.count += 1;
      m.set(key, cur);
    });
    const list = k => [...groups[k].values()].sort((a, b) => b.count - a.count || a.name.localeCompare(b.name, 'de'));
    const closure = CLOSURES[cfg.closure] || CLOSURES.silver;
    return {
      naturalStones: list('stone'),
      designBeads: list('designBead'),
      spacers: list('spacer'),
      rondelle: list('rondell'),
      closure: { finish: closure.id, label: `Verschlussperle ${closure.label}`, detail: `${closure.material} · ${CLOSURE_MM} mm` },
      counts: { naturalStones: order.filter(o => o.kind === 'stone').length, designBeads: order.filter(o => o.kind === 'designBead').length, spacers: order.filter(o => o.kind === 'spacer').length, rondelle: order.filter(o => o.kind === 'rondell').length }
    };
  }

  // Geometrie fuer Fertigungsbild: Elemente entlang des Umfangs proportional zur Laenge (Verschluss bei 6 Uhr).
  // ---------------------------------------------------------------------------------------------------------------------
  // Ring-Umbau OHNE Neuzuordnung. Aendert sich die Platzanzahl (Spacer gesetzt/entfernt, Groesse gewechselt), werden NUR leere Plaetze entfernt bzw.
  // neue leere Plaetze angehaengt. Die zyklische Reihenfolge aller uebrigen Elemente (Kugeln, Spacer, Verschlussperle) bleibt dabei unveraendert.
  //
  // Hintergrund: Die Plaetze sind ein Array; die Verschlussperle sitzt rechnerisch nach dem mittleren Platz (Index ceil(n/2)-1), Spacer-Positionen sind
  // "Luecke nach Platz i" bzw. "closure-left"/"closure-right". Wuerde man einfach einen Platz aus dem Array streichen, wanderte die Verschlussperle
  // gegenueber den Kugeln (Mitte verschiebt sich) und Kugeln landeten auf der anderen Seite eines Spacers/der Verschlussperle. Deshalb wird der Ring
  // als Leseliste ab der Verschlussperle (Luecke, Platz, Luecke, ..., Platz, Luecke) umgebaut und danach so ins Array zurueckgeschrieben, dass die
  // Verschlussperle wieder nach dem mittleren Platz sitzt (reine Drehung des Arrays; Server und Fertigungsreihenfolge bleiben unveraendert).
  //
  // Regeln:
  //  - Entfernt werden nur leere Plaetze. Reihenfolge der Kandidaten: zuletzt gezielt geleerte Plaetze (freed, juengster zuerst), danach die leeren
  //    Plaetze in Leserichtung von hinten (naechster zur Verschlussperle am Ende der Leserichtung). Ein Kandidat, dessen Entfernen zwei Spacer
  //    direkt aneinander grenzen liesse (Spacer-Verlust), wird uebersprungen; gibt es keinen anderen, wird NICHTS veraendert (collision = true).
  //  - Neue leere Plaetze werden am Ende der Leserichtung eingefuegt, unmittelbar vor der Verschlussperle (hinter einem dort liegenden Spacer).
  //  - Belegte Plaetze werden nie entfernt oder ersetzt (zu wenig leere Plaetze -> ok = false, notEmpty = fehlende Anzahl).
  // Eingabe: { slots, gaps, freed (Array-Indizes, juengster zuletzt), target (neue Platzanzahl) }. Ausgabe: { ok, slots, gaps, freed, collision, notEmpty }.
  function closureAfterIndex(n) { return n > 0 ? Math.ceil(n / 2) - 1 : -1; }

  function restructureRing({ slots, gaps = [], freed = [], target }) {
    const n = slots.length;
    const unchanged = { ok: true, slots: slots.slice(), gaps: gaps.slice(), freed: freed.slice(), collision: false, notEmpty: 0 };
    if (!Number.isInteger(target) || target < 0) return { ...unchanged, ok: false };
    if (target === n) return unchanged;
    // Leseliste ab der Verschlussperle: [Luecke(CL), Platz, Luecke, Platz, ..., Platz, Luecke(CR)]
    const a = closureAfterIndex(n);
    const gapSet = new Set(gaps);
    let R = [{ gap: true, spacer: gapSet.has(CLOSURE_LEFT) }];
    for (let k = 0; k < n; k++) {
      const idx = (a + 1 + k) % n;
      R.push({ item: true, idx, content: slots[idx] || null });
      R.push({ gap: true, spacer: k === n - 1 ? (gapSet.has(CLOSURE_RIGHT) || gapSet.has(a)) : gapSet.has(idx) });
    }
    let freedRefs = freed.filter(i => Number.isInteger(i) && i >= 0 && i < n && !slots[i]);
    let dropCount = n - target;
    if (dropCount > 0) {
      const emptyCount = R.filter(e => e.item && !e.content).length;
      if (emptyCount < dropCount) return { ...unchanged, ok: false, notEmpty: dropCount - emptyCount };
      for (let d = 0; d < dropCount; d++) {
        const emptyPos = []; // Positionen in R, leere Plaetze
        R.forEach((e, j) => { if (e.item && !e.content) emptyPos.push(j); });
        const byIdx = new Map(emptyPos.map(j => [R[j].idx, j]));
        const order = [];
        for (let f = freedRefs.length - 1; f >= 0; f--) if (byIdx.has(freedRefs[f]) && !order.includes(byIdx.get(freedRefs[f]))) order.push(byIdx.get(freedRefs[f]));
        for (let q = emptyPos.length - 1; q >= 0; q--) if (!order.includes(emptyPos[q])) order.push(emptyPos[q]);
        const collides = j => R[j - 1].spacer && R[j + 1].spacer;
        const pick = order.find(j => !collides(j));
        if (pick === undefined) return { ...unchanged, ok: false, collision: true };
        const merged = R[pick - 1].spacer || R[pick + 1].spacer;
        if (pick + 1 === R.length - 1) { R[pick + 1].spacer = merged; R.splice(pick - 1, 2); } else { R[pick - 1].spacer = merged; R.splice(pick, 2); }
      }
    } else {
      for (let g = 0; g < target - n; g++) R.push({ item: true, idx: -1 - g, content: null }, { gap: true, spacer: false });
    }
    // zurueck ins Array: Verschlussperle nach dem mittleren Platz
    const items = R.filter(e => e.item);
    const m = items.length;
    const p = closureAfterIndex(m);
    const newSlots = new Array(m);
    const newIndexOf = new Map();
    items.forEach((it, k) => { const pos = (p + 1 + k) % m; newSlots[pos] = it.content; newIndexOf.set(it, pos); });
    const outGaps = [];
    const gapEls = R.filter(e => e.gap);
    gapEls.forEach((g, k) => {
      if (!g.spacer) return;
      if (k === 0) outGaps.push(CLOSURE_LEFT);
      else if (k === gapEls.length - 1) outGaps.push(CLOSURE_RIGHT);
      else outGaps.push((p + k) % m); // Luecke zwischen Platz k-1 und k der Leseliste = nach Array-Index (p + 1 + (k-1)) % m
    });
    const regular = outGaps.filter(g => typeof g === 'number').sort((x, y) => x - y);
    const tokens = outGaps.filter(g => typeof g !== 'number').sort();
    const byOldIdx = new Map(items.filter(it => it.idx >= 0).map(it => [it.idx, newIndexOf.get(it)]));
    const newFreed = freedRefs.filter(i => byOldIdx.has(i)).map(i => byOldIdx.get(i));
    return { ok: true, slots: newSlots, gaps: [...regular, ...tokens.filter(t => t === CLOSURE_LEFT), ...tokens.filter(t => t === CLOSURE_RIGHT)], freed: newFreed, collision: false, notEmpty: 0 };
  }

  function layoutRing(order, radius) {
    const VISUAL_MIN_MM = 2;
    const widths = order.map(o => (o.kind === 'spacer' || o.kind === 'rondell') ? Math.max(VISUAL_MIN_MM, o.widthMm) : o.widthMm);
    const total = widths.reduce((a, b) => a + b, 0) || 1;
    const closureW = widths[0];
    let cursor = 90 + (closureW / 2) / total * 360;
    const out = [];
    order.forEach((o, i) => {
      const span = widths[i] / total * 360;
      let mid;
      if (i === 0) { mid = 90; } else { mid = cursor + span / 2; cursor += span; }
      const rad = mid * Math.PI / 180;
      out.push({ ...o, angle: mid, x: radius * Math.cos(rad), y: radius * Math.sin(rad), spanDeg: span, visualWidthMm: widths[i] });
    });
    return out;
  }

  return { BEAD_MM, CLOSURE_MM, BASE_SLOTS, CLOSURES, CLOSURE_LEFT, CLOSURE_RIGHT, cents, fromCents, euro, baseSlotCount, restructureRing, allModeStatus, allModeNotice, SIZES, LEGACY_SIZES, RETIRED_SIZES, DEFAULT_SIZE_KEY, sizeInfo, sizeText, currentSizeKey, restoreSizeInfo, sizeCircumferenceLabel, allModeAvailable, computeStoneCapacity, capacity, removedStonesRequired, spacerCount, filledCount, visibleIndexes, closurePreceding, pricing, validate, sequence, readingOrder, materials, layoutRing, spacerKind, cleanName, SPACER_RULES, spacerRule, SPACER_DISPLAY, spacerFixedLabel, applySpacerDisplay, requiredRemovedStonesForSingle6mmSpacer, requiredRemovedStonesForRondell, requiredRemovedStonesForMultiSizeSpacer };
});
/* DYO-ENGINE:END */
/* DYO-ENGINE-SYNC:END */
(() => {
  // Die Section-ID kommt aus dem data-Attribut des Script-Tags (frueher direkt per Liquid im Inline-Skript).
  const SECTION_SCRIPT = document.currentScript;
  const SECTION_ID = SECTION_SCRIPT && SECTION_SCRIPT.dataset ? SECTION_SCRIPT.dataset.dyoSectionId : '';
  const root = document.getElementById('DyoConfigurator-' + SECTION_ID) || document.querySelector('[id^="DyoConfigurator-"]');
  if (!root) return;

  const THEME_STORAGE_KEY = 'dyochain-configurator-theme';

  function dyoReadStoredTheme() {
    try {
      return window.localStorage.getItem(THEME_STORAGE_KEY) === 'light' ? 'light' : 'dark';
    } catch (err) {
      return 'dark';
    }
  }

  function dyoApplyTheme(theme) {
    const resolved = theme === 'light' ? 'light' : 'dark';
    root.setAttribute('data-dyo-theme', resolved);
    root.querySelectorAll('[data-theme-btn]').forEach((btn) => {
      btn.setAttribute('aria-pressed', btn.dataset.themeBtn === resolved ? 'true' : 'false');
    });
  }

  dyoApplyTheme(dyoReadStoredTheme());

  const API_BASE = 'https://dyochain-api-production.up.railway.app/api';
  const SHOPIFY_FILE_BASE = 'https://cdn.shopify.com/s/files/1/0908/5563/7320/files/';

  const state = {

    bedeutungsklassen: [],
    perlen: [],
    groessen: [],
    einstellungen: {},

    stoneFilter: 'all',
    premiumColorFilter: 'all',
    selectedPerleId: null,
    groesse: null,
    slots: [],
    history: [],
    perlenAufpreis: 0,
    totalPreis: 0,

    spacer: [],
    selectedSpacerId: null,
    activeSpacerId: null,
    spacerMode: 'none',
    spacerGaps: [],
    manualPreviewMode: false,
    spacerAufpreis: 0,
    spacerConflict: false,

    spacerConflictCount: 0,

    spacerConflictContext: null,

    mobileSelectionTab: 'natursteine',

    deleteMode: false,

    hiddenEmptySlots: 0,

    spacerConflictCandidate: null,
    spacerNotice: null,

    conflictOverlayDismissed: false,

    premiumKugeln: [],
    selectedPremiumKugelId: null,

    stoneTypeTab: 'naturalStone',

    activeSelectionType: 'naturalStone',

    closureBead: 'silver'
  };

  const stage = root.querySelector('[data-stage]');
  const slotRoot = root.querySelector('[data-slots]');
  const wristRoot = root.querySelector('[data-wrist-size]');
  const spacerStepRoot = root.querySelector('[data-spacer-step]');
  const manualPreviewToggleBtn = root.querySelector('[data-manual-preview-toggle]');
  const totalEl = root.querySelector('[data-total-price]');
  const summaryEl = root.querySelector('[data-summary]');
  const addBtn = root.querySelector('[data-add]');
  const undoBtn = root.querySelector('[data-undo]');
  const mobilePriceEl = root.querySelector('[data-mobile-price]');
  const mobileMetaEl = root.querySelector('[data-mobile-meta]');
  const mobileSlotsEl = root.querySelector('[data-mobile-slots]');
  const mobileCartSlider = root.querySelector('[data-mobile-cart-slider]');
  const mobileCartHandle = root.querySelector('[data-mobile-cart-handle]');
  const mobileCartLabel = root.querySelector('[data-mobile-cart-label]');
  const mobileCartContent = root.querySelector('[data-mobile-cart-content]');
  const MOBILE_CART_LABEL = 'Design in den Warenkorb';
  const MOBILE_CART_HANDLE_SIZE = 40;
  const MOBILE_CART_HANDLE_INSET = 4;
  const MOBILE_CART_THRESHOLD = 0.88;
  let cartRequestBusy = false;
  let mobileCartSliderBusy = false;

  function money(value) {
    return Number(value || 0).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR'
    });
  }

  function getBasispreis() {
    return Number(state.einstellungen.basispreis || 20);
  }

  // Grundplaetze der Natursteine je Groesse (24/26/28/31/33/35; der Platz der Verschlussperle ist bereits abgezogen): zentrale Engine.
  function getBaseSlotCount(sizeCode) {
    return window.DyoEngine.baseSlotCount(sizeCode);
  }

  const BEAD_DIAMETER_MM = 6;

  const CLOSURE_BEAD_SIZE_MM = 4;
  const CLOSURE_BEAD_DEFAULT = 'silver';
  const CLOSURE_BEAD_OPTIONS = {
    silver: {
      id: 'silver',
      label: 'Silber',
      sizeMm: CLOSURE_BEAD_SIZE_MM,
      materialLabel: '925er Silber',
      cartLabel: '925er Silber 4 mm'
    },
    gold: {
      id: 'gold',
      label: 'Gold',
      sizeMm: CLOSURE_BEAD_SIZE_MM,
      materialLabel: '14K Gold PVD',
      cartLabel: 'Gold · 14K Gold PVD · 4 mm'
    }
  };

  const CLOSURE_GAP_LEFT = 'closure-left';
  const CLOSURE_GAP_RIGHT = 'closure-right';
  const CLOSURE_GAP_IDS = [CLOSURE_GAP_LEFT, CLOSURE_GAP_RIGHT];
  const CLOSURE_GOLD_KUGEL_ID = 3;
  const CLOSURE_SILVER_IMAGE_FILE = 'Verschlussperle_Silber_4mm_konfi.png';
  const CLOSURE_BEAD_IMAGE_SOURCES = {
    gold: () => {
      const kugel = state.premiumKugeln.find(k => Number(k.id) === CLOSURE_GOLD_KUGEL_ID);
      return kugel ? premiumKugelImageUrl(kugel) : '';
    },
    silver: () => SHOPIFY_FILE_BASE + CLOSURE_SILVER_IMAGE_FILE
  };

  function closureWidthPx(slotSize) {
    return slotSize * (CLOSURE_BEAD_SIZE_MM / BEAD_DIAMETER_MM);
  }

  function parseGapId(raw) {
    return /^\d+$/.test(String(raw)) ? Number(raw) : String(raw);
  }

  // Kapazitaet: EINE zentrale Regel (DyoEngine.capacity). Der Konfigurator rechnet nirgends selbst.
  function candidateConfig(overrides) {
    return { ...buildEngineConfig(), ...overrides };
  }

  function getMaxStoneCount() {
    return window.DyoEngine.capacity(buildEngineConfig());
  }

  function getSlotCount() {
    return getMaxStoneCount();
  }

  function getAllowedStoneCountForCandidate(candidateGaps, candidateMode) {
    const overrides = {};
    if (candidateGaps !== undefined) overrides.gaps = candidateGaps;
    if (candidateMode !== undefined) overrides.spacerMode = candidateMode;
    return window.DyoEngine.capacity(candidateConfig(overrides));
  }

  function hasSpacerStoneConflict(candidateGaps, candidateMode) {
    const filled = state.slots.filter(Boolean).length;
    const allowed = getAllowedStoneCountForCandidate(candidateGaps, candidateMode);
    return filled > allowed;
  }

  function stonesPhrase(n) {
    return n === 1 ? 'eine Natursteinkugel' : n + ' Natursteinkugeln';
  }

  function removalSentence(n) {
    return n === 1 ? 'muss zuerst eine Natursteinkugel entfernt werden' : 'müssen zuerst ' + n + ' Natursteinkugeln entfernt werden';
  }

  // Abgelehnte Aktion: Es wird NICHTS gesetzt, vorgemerkt oder reserviert. Es erscheint nur ein Hinweis; der Kunde entfernt die
  // erforderlichen Natursteine selbst und fuehrt die Aktion danach erneut aus.
  function refuseSpacerAction(text) {
    state.spacerNotice = { text };
    return false;
  }

  function setSpacerGaps(newGaps) {
    const filled = state.slots.filter(Boolean).length;
    const allowed = getAllowedStoneCountForCandidate(newGaps, state.spacerMode);
    if (filled > allowed) {
      const need = filled - allowed;
      return refuseSpacerAction('Für den ' + newGaps.length + '. Spacer ' + removalSentence(need) + '.');
    }

    if (spacerLossOnResize(newGaps, state.spacerMode, allowed)) return refuseSpacerAction(SPACER_COLLISION_TEXT);

    pushHistory();
    state.spacerGaps = [...newGaps];
    state.spacerConflict = false;
    state.spacerConflictCount = 0;
    state.spacerConflictContext = null;
    state.spacerConflictCandidate = null;
    state.conflictOverlayDismissed = false;
    return true;
  }

  function setSpacerMode(newMode) {
    if (newMode !== 'none' && newMode !== 'manual' && newMode !== 'all') return false;

    if (newMode === 'all' && !window.DyoEngine.allModeAvailable(candidateConfig({ spacerMode: 'all' }))) {
      return refuseSpacerAction(window.DyoEngine.allModeNotice(candidateConfig({ spacerMode: 'all' })));
    }
    const gapsForCheck = newMode === 'none' ? [] : state.spacerGaps;
    const filled = state.slots.filter(Boolean).length;
    const allowed = getAllowedStoneCountForCandidate(gapsForCheck, newMode);
    if (filled > allowed) {
      const need = filled - allowed;
      return refuseSpacerAction(newMode === 'all'
        ? 'Für „Zwischen allen“ passen bei dieser Größe höchstens ' + allowed + ' Natursteine. Entferne zuerst ' + stonesPhrase(need) + '.'
        : 'Mit den gesetzten Spacern passen höchstens ' + allowed + ' Natursteine. Entferne zuerst ' + stonesPhrase(need) + '.');
    }

    pushHistory();
    state.spacerMode = newMode;
    if (newMode !== 'manual') {
      state.spacerGaps = [];
      state.manualPreviewMode = false;
    }
    state.spacerConflict = false;
    state.spacerConflictCount = 0;
    state.spacerConflictContext = null;
    state.spacerConflictCandidate = null;
    state.conflictOverlayDismissed = false;
    return true;
  }

  // Spacer-Auswahl wechseln (Spacer-Karte): wuerde die neue Regel weniger Natursteinplaetze lassen als belegt sind, wird abgelehnt.
  function canSwitchSpacerTo(spacerId) {
    const candidate = state.spacer.find(item => Number(item.id) === Number(spacerId));
    if (!candidate || state.spacerMode === 'none') return true;
    const filled = state.slots.filter(Boolean).length;
    if (state.spacerMode === 'all' && !window.DyoEngine.allModeAvailable(candidateConfig({ spacer: candidate }))) {
      refuseSpacerAction(window.DyoEngine.allModeNotice(candidateConfig({ spacer: candidate })));
      return false;
    }
    const allowed = window.DyoEngine.capacity(candidateConfig({ spacer: candidate }));
    if (filled > allowed) {
      const need = filled - allowed;
      refuseSpacerAction('Mit diesem Spacer passen bei den aktuellen Einstellungen höchstens ' + allowed + ' Natursteine. Entferne zuerst ' + stonesPhrase(need) + ' oder stelle den Spacer-Modus um.');
      return false;
    }
    if (spacerLossOnResize(state.spacerGaps, state.spacerMode, allowed)) { refuseSpacerAction(SPACER_COLLISION_TEXT); return false; }
    return true;
  }

  // Groesse wechseln: es werden nie stillschweigend Natursteine entfernt.
  function canSwitchSizeTo(group) {
    if (!group) return true;
    const filled = state.slots.filter(Boolean).length;
    const allowed = window.DyoEngine.capacity(candidateConfig({ size: group.key }));
    if (filled > allowed) {
      const need = filled - allowed;
      refuseSpacerAction('Für Größe ' + group.groesse + ' (ca. ' + group.cm + ' cm) sind bei den aktuellen Einstellungen ' + allowed + ' Natursteinplätze vorgesehen. Entferne zuerst ' + stonesPhrase(need) + '.');
      return false;
    }
    if (state.spacerMode === 'all' && !window.DyoEngine.allModeAvailable(candidateConfig({ size: group.key }))) {
      refuseSpacerAction('Größe ' + group.groesse + ' (ca. ' + group.cm + ' cm): ' + window.DyoEngine.allModeNotice(candidateConfig({ size: group.key })));
      return false;
    }
    if (spacerLossOnResize(state.spacerGaps, state.spacerMode, allowed)) { refuseSpacerAction(SPACER_COLLISION_TEXT); return false; }
    return true;
  }

  function resolvePendingIfPossible() {
    if (!state.spacerConflict || !state.spacerConflictCandidate) return false;
    const pending = { gaps: [...state.spacerConflictCandidate.gaps], mode: state.spacerConflictCandidate.mode };
    reevaluateSpacerConflict();
    if (state.spacerConflict) return false;
    if ((state.hiddenEmptySlots || 0) > 0) applyPendingPlacement(pending);
    return true;
  }

  function reevaluateSpacerConflict() {
    if (!state.spacerConflict || !state.spacerConflictCandidate) return;
    const filled = state.slots.filter(Boolean).length;
    const candidate = state.spacerConflictCandidate;
    const allowed = getAllowedStoneCountForCandidate(candidate.gaps, candidate.mode);
    const remaining = filled - allowed;
    if (remaining <= 0) {
      state.spacerConflict = false;
      state.spacerConflictCount = 0;
      state.spacerConflictContext = null;
      state.spacerConflictCandidate = null;
      state.conflictOverlayDismissed = false;
    } else {
      state.spacerConflictCount = remaining;
    }
  }

  function capacityReleaseNeeded() {
    return state.spacerConflict === true &&
      Number(state.spacerConflictCount) > 0 &&
      !!state.spacerConflictCandidate;
  }

  function removeStoneFromSlot(index) {
    pushHistory();
    state.slots[index] = null;
    state.freedSlots = [...(state.freedSlots || []).filter(i => i !== index), index];
    updateSlotVisuals();
    updatePriceAndSummary();
  }

  function remapGapsAfterRemoval(gaps, index, len) {
    return [...new Set(gaps.map(g => {
      if (g === index) return (index - 1 + len) % len;
      return g > index ? g - 1 : g;
    }))];
  }

  // Der Verschluss sitzt mittig unter den Plaetzen und wandert mit, wenn sich deren Anzahl aendert. Die Spacer-Positionen direkt
  // am Verschluss ("closure-right"/"closure-left") werden deshalb VOR der Aenderung an den konkreten Platz gebunden und danach
  // neu zugeordnet. So geht kein Spacer verloren, nur weil der Verschluss um einen Platz weiterrutscht.
  function closureIndexFor(len) {
    return len > 0 ? Math.ceil(len / 2) - 1 : null;
  }

  function reanchorGaps(gaps, oldLen, removedDesc, newLen) {
    const p0 = closureIndexFor(oldLen);
    const p1 = closureIndexFor(newLen);
    const hasR = gaps.some(g => g === CLOSURE_GAP_RIGHT || g === p0);
    const hasL = gaps.includes(CLOSURE_GAP_LEFT);
    const regular = gaps.filter(g => g !== CLOSURE_GAP_RIGHT && g !== CLOSURE_GAP_LEFT && g !== p0);
    const renumber = i => {
      let len = oldLen;
      let v = i;
      removedDesc.forEach(e => {
        len -= 1;
        if (len <= 0) return;
        v = v === e ? (e - 1 + len) % len : (v > e ? v - 1 : v);
      });
      return v;
    };
    // Variante A: die Spacer am Verschluss bleiben am Verschluss; uebrige Spacer bleiben an ihren Plaetzen.
    const a = new Set();
    if (hasR) a.add(CLOSURE_GAP_RIGHT);
    if (hasL) a.add(CLOSURE_GAP_LEFT);
    regular.forEach(g => { const v = renumber(g); a.add(v === p1 ? CLOSURE_GAP_RIGHT : v); });
    // Variante B: auch die Spacer am Verschluss bleiben an ihrem Platz, der Verschluss rutscht an ihnen vorbei.
    const b = new Set();
    const vp = renumber(p0);
    [[hasR, 'R'], [hasL, 'L']].forEach(([has, side]) => {
      if (!has) return;
      b.add(vp === p1 ? (side === 'L' ? CLOSURE_GAP_LEFT : CLOSURE_GAP_RIGHT) : vp);
    });
    regular.forEach(g => { const v = renumber(g); b.add(v === p1 ? CLOSURE_GAP_RIGHT : v); });
    return [...(a.size > b.size ? a : b)];
  }

  // Wuerde die noetige Anpassung der Platzanzahl zwei Spacer zusammenfallen lassen (z. B. beide Seiten des Verschlusses oder zwei
  // Spacer, die durch den entfallenden Platz direkt aneinander grenzen)? Dann wird die Aktion abgelehnt statt still einen zu verlieren.
  function spacerLossOnResize(gaps, mode, targetCount) {
    if (mode !== 'manual' || !gaps.length || (state.hiddenEmptySlots || 0) > 0) return false;
    if (targetCount === state.slots.length) return false;
    return window.DyoEngine.restructureRing({ slots: state.slots, gaps, freed: state.freedSlots || [], target: targetCount }).collision === true;
  }

  // Ring-Umbau ohne Neuzuordnung (Engine): entfernt nur leere Plaetze bzw. haengt leere an, Reihenfolge von Kugeln, Spacern und Verschluss bleibt.
  function applyRingRestructure(targetCount) {
    const r = window.DyoEngine.restructureRing({ slots: state.slots, gaps: state.spacerGaps, freed: state.freedSlots || [], target: targetCount });
    if (!r.ok) return false;
    state.slots = r.slots;
    state.spacerGaps = r.gaps;
    state.freedSlots = r.freed;
    return true;
  }

  const SPACER_COLLISION_TEXT = 'Dabei würden zwei Spacer direkt nebeneinander liegen. Verschiebe oder entferne zuerst einen der betroffenen Spacer.';

  function applyPendingPlacement(pending) {
    state.spacerMode = pending.mode;
    state.spacerGaps = [...pending.gaps];
    if (pending.mode !== 'manual') state.manualPreviewMode = false;
    adjustSlotsToSize();
  }

  function removeStoneAndReleaseCapacity(index) {
    pushHistory();
    state.slots.splice(index, 1);
    state.slots.push(null);
    state.freedSlots = [];
    state.hiddenEmptySlots = (state.hiddenEmptySlots || 0) + 1;

    const len = state.slots.length;
    if (state.spacerGaps.length) {
      state.spacerGaps = remapGapsAfterRemoval(state.spacerGaps, index, len);
    }

    const pending = state.spacerConflictCandidate
      ? { gaps: remapGapsAfterRemoval(state.spacerConflictCandidate.gaps, index, len), mode: state.spacerConflictCandidate.mode }
      : null;
    if (pending) state.spacerConflictCandidate = { gaps: [...pending.gaps], mode: pending.mode };

    resolvePendingIfPossible();

    renderSlots();
    updatePriceAndSummary();
  }

  const STONE_GRADIENTS = {
    lapis: 'radial-gradient(circle at 30% 24%, #6f8fd8 0%, #2c4faa 12%, #1a3a8f 30%, #0e2260 52%, #d8b968 56%, #0c1d52 60%, #16337a 100%)',
    amazonit: 'radial-gradient(circle at 32% 26%, #eafff6 0%, #7fd9c4 16%, #4aab97 38%, #dff5ec 52%, #3d8f7d 68%, #8fe0cc 84%, #2f7364 100%)',
    achat: 'radial-gradient(circle at 32% 28%, #d9c7b8 0%, #b89a83 20%, #8c6f5a 42%, #d4bda8 58%, #6e5342 76%, #a68968 100%)',
    rosenquarz: 'radial-gradient(circle at 30% 24%, #fff8f7 0%, #f7d3d6 18%, #eeb3ba 40%, #fbe5e6 56%, #d98d97 74%, #f4c5cb 100%)',
    mondstein: 'radial-gradient(circle at 28% 22%, #ffffff 0%, #eef3fb 12%, #cdd9ee 30%, #a9c2e8 44%, #f2f6fc 56%, #8fa8d6 74%, #d7e2f4 100%)',
    aventurin: 'radial-gradient(circle at 30% 25%, #e3ffe9 0%, #8fd6a0 18%, #4f9d64 40%, #cdeed4 54%, #2f7a45 72%, #79c48c 100%)',
    citrin: 'radial-gradient(circle at 30% 24%, #fff6c9 0%, #f4d873 18%, #d9a838 40%, #fbecab 54%, #b3831f 74%, #e8bd4f 100%)',
    tigerauge: 'radial-gradient(circle at 30% 22%, #f4d9a0 0%, #c9932f 16%, #7a5417 34%, #e8b45a 46%, #4a3410 62%, #a4741f 78%, #8a5f1a 100%)',
    howlith: 'radial-gradient(circle at 30% 25%, #ffffff 0%, #f2f0ea 18%, #d9d4c6 42%, #f7f5ef 58%, #b8b09a 78%, #e0dbcb 100%)',
    bergkristall: 'radial-gradient(circle at 28% 22%, #ffffff 0%, #f4faff 14%, #dce8f2 32%, #f9fcff 46%, #c3d6e4 64%, #eef6fb 82%, #b9cddc 100%)'
  };

  const TRANSLUCENT_STONES = ['rosenquarz', 'mondstein', 'bergkristall', 'amethyst', 'citrin'];

  function deriveBeadFinish(perle) {
    const name = (perle.name || '').toLowerCase();
    if (name.includes('matt')) return 'matte';
    if (TRANSLUCENT_STONES.some(s => name.includes(s))) return 'translucent';
    return 'glossy';
  }

  function beadGradient(perle) {
    const farbe = (perle.farbe || '').toLowerCase();

    if (farbe.includes('türkis')) return 'radial-gradient(circle at 32% 28%, #d9fff1 0 8%, #82c9bd 24%, #4ca69a 50%, #b8e1d8 72%, #6bb8ad 100%)';
    if (farbe.includes('rot')) return 'radial-gradient(circle at 32% 28%, #f0c0bd 0 7%, #7b1d22 35%, #32090d 70%, #a53a3f 100%)';
    if (farbe.includes('grün')) return 'radial-gradient(circle at 32% 28%, #e7fff0 0 8%, #80b889 30%, #3d7d54 65%, #b7d7c3 100%)';
    if (farbe.includes('blau')) return 'radial-gradient(circle at 32% 28%, #d8e4ff 0 8%, #3155b8 36%, #071d6b 66%, #0b2374 100%)';
    if (farbe.includes('gelb')) return 'radial-gradient(circle at 32% 28%, #fff6bf 0 9%, #e7b438 35%, #b87914 68%, #f4cf61 100%)';
    if (farbe.includes('orange')) return 'radial-gradient(circle at 30% 25%, #ffd69a 0 10%, #ec8d35 38%, #c85f1b 70%, #ffc070 100%)';
    if (farbe.includes('rosa')) return 'radial-gradient(circle at 30% 25%, #fff2f2 0 10%, #e8aeb2 35%, #c98089 62%, #f2d0d0 100%)';
    if (farbe.includes('violett')) return 'radial-gradient(circle at 30% 25%, #e7d6ff 0 10%, #8c58b7 35%, #4f2572 68%, #b88bd9 100%)';
    if (farbe.includes('weiß')) return 'radial-gradient(circle at 32% 28%, #ffffff 0 9%, #e8e5dc 35%, #bfc0ba 65%, #f7f4ed 100%)';
    if (farbe.includes('schwarz')) return 'radial-gradient(circle at 30% 25%, #666 0 6%, #242424 38%, #050505 100%)';
    if (farbe.includes('braun')) return 'radial-gradient(circle at 30% 25%, #d7a76f 0 8%, #8b4d32 35%, #4a281f 62%, #c17b50 100%)';

    return 'radial-gradient(circle at 30% 25%, #ffffff 0 8%, #b7d7c3 35%, #6c9278 70%, #dcebe2 100%)';
  }

  function beadGradientRing(perle) {
    const name = (perle.name || '').toLowerCase();
    for (const key in STONE_GRADIENTS) {
      if (name.includes(key)) return STONE_GRADIENTS[key];
    }
    return beadGradient(perle);
  }

  function getSelectedPerle() {
    return state.perlen.find(perle => Number(perle.id) === Number(state.selectedPerleId));
  }

  function getSelectedPremiumKugel() {
    return state.premiumKugeln.find(k => Number(k.id) === Number(state.selectedPremiumKugelId));
  }

  function getSelectedSlotContent() {
    if (state.activeSelectionType === 'premiumBead') return getSelectedPremiumKugel();
    if (state.activeSelectionType === 'naturalStone') return getSelectedPerle();
    return null;
  }

  function getActiveSpacer() {
    return state.spacer.find(spacer => Number(spacer.id) === Number(state.activeSpacerId));
  }

  function setActiveSelection(type, id) {
    state.selectedPerleId = type === 'naturalStone' ? id : null;
    state.selectedPremiumKugelId = type === 'premiumBead' ? id : null;
    state.selectedSpacerId = type === 'spacer' ? id : null;
    state.activeSelectionType = type;
    renderPerlen();
    renderPremiumKugelStep();
    renderSpacerStep();
  }

  function getSpacerCount() {
    return window.DyoEngine.spacerCount(buildEngineConfig());
  }

  function getSpacerAufpreis() {
    const selected = getActiveSpacer();
    if (!selected) return 0;
    return getSpacerCount() * Number(selected.aufpreis || 0);
  }

  const DyoEngine = window.DyoEngine;

  function buildEngineConfig() {
    return {
      size: state.groesse ? state.groesse.key : null,
      closure: state.closureBead,
      spacerMode: state.spacerMode,
      spacer: getActiveSpacer() || null,
      gaps: state.spacerGaps,
      slots: state.slots,
      hidden: state.hiddenEmptySlots || 0
    };
  }

  function getOrderability() {
    return DyoEngine.validate(buildEngineConfig());
  }

  function renderCartReason(check) {
    const text = check.orderable ? '' : check.reasons[0].text;
    root.querySelectorAll('[data-cart-reason]').forEach(el => {
      el.textContent = text;
      el.hidden = !text;
    });
  }

  const diag = { log: [], t0: Date.now(), sent: new Set() };

  function logDiag(action, extra) {
    const check = getOrderability();
    diag.log.push({
      t: Math.round((Date.now() - diag.t0) / 100) / 10,
      a: action,
      f: check.stats.filled,
      c: check.stats.capacity,
      sp: check.stats.spacers,
      m: state.spacerMode,
      h: check.stats.hidden,
      x: extra || undefined
    });
    if (diag.log.length > 40) diag.log.shift();
  }

  function sendDiagnostic(reason) {
    if (diag.sent.has(reason)) return;
    diag.sent.add(reason);
    try {
      const check = getOrderability();
      const payload = {
        v: 1,
        reason,
        size: state.groesse ? state.groesse.key : null,
        closure: state.closureBead,
        mode: state.spacerMode,
        spacerId: state.activeSpacerId,
        gaps: state.spacerGaps.length,
        stats: check.stats,
        codes: check.reasons.map(r => r.code),
        conflict: state.spacerConflict ? state.spacerConflictCount : 0,
        steps: diag.log
      };
      navigator.sendBeacon(`${API_BASE}/diagnostics`, new Blob([JSON.stringify(payload)], { type: 'text/plain' }));
    } catch (err) {}
  }

  function checkInvariants() {
    const stats = getOrderability().stats;
    const visibleCount = state.slots.length - (state.hiddenEmptySlots || 0);
    if (!state.spacerConflict && visibleCount !== stats.capacity && stats.filled <= stats.capacity) {
      sendDiagnostic('inv_visible_ne_capacity');
    }
  }

  async function fetchJson(url) {
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error('API Fehler: ' + url);
    return response.json();
  }

  async function fetchSpacerSafe() {
    try {
      const spacer = await fetchJson(`${API_BASE}/spacer`);
      return Array.isArray(spacer) ? spacer.map(item => window.DyoEngine.applySpacerDisplay(item)) : [];
    } catch (error) {
      console.warn('DYO: Spacer konnten nicht geladen werden (optional, Konfigurator laeuft trotzdem weiter).', error);
      return [];
    }
  }

  async function fetchPremiumKugelnSafe() {
    try {
      const kugeln = await fetchJson(`${API_BASE}/premium_kugel`);
      return Array.isArray(kugeln)
        ? kugeln.map(k => ({ ...k, contentType: 'premiumBead' }))
        : [];
    } catch (error) {
      console.warn('DYO: Premium-Kugeln konnten nicht geladen werden (optional, Konfigurator laeuft trotzdem weiter).', error);
      return [];
    }
  }

  async function init() {
    try {

      syncClosureChips();
      const spacerPromise = fetchSpacerSafe();
      const premiumKugelnPromise = fetchPremiumKugelnSafe();

      const [bedeutungsklassen, einstellungen] = await Promise.all([
        fetchJson(`${API_BASE}/bedeutungsklassen`),
        fetchJson(`${API_BASE}/einstellungen`)
      ]);

      // Die Groessen (Bezeichnung, Umfang, Plaetze) kommen aus der zentralen Engine-Tabelle, nicht aus dem Katalog. id = Platzanzahl.
      const groessen = window.DyoEngine.SIZES.map(z => ({ id: z.slots, key: z.key, groesse: z.label, cm: z.cm, slots: z.slots }));
      state.bedeutungsklassen = bedeutungsklassen;
      state.groessen = groessen;
      state.einstellungen = einstellungen;
      state.spacer = await spacerPromise;
      state.premiumKugeln = await premiumKugelnPromise;
      syncClosureChips();

      state.groesse = groessen.find(g => g.key === window.DyoEngine.DEFAULT_SIZE_KEY) || groessen[0];

      await loadPerlen();
      resetSlots();
      renderAll();

      const restoreParams = new URLSearchParams(window.location.search);
      const restoreId = restoreParams.get('design_id');
      const restoreToken = restoreParams.get('dt');
      if (restoreId) await (restoreToken ? restoreDesignFromServer(restoreId, restoreToken) : restoreDesign(restoreId));
    } catch (error) {
      console.error(error);
      root.insertAdjacentHTML('beforeend', '<p style="color:red;">Konfigurator konnte nicht geladen werden. Bitte versuche es erneut.</p>');
    }
  }

  async function loadPerlen() {
    const perlen = await fetchJson(`${API_BASE}/perlen`);
    state.perlen = perlen.map(p => ({ ...p, contentType: 'naturalStone' }));
    state.selectedPerleId = state.perlen[0]?.id || null;
  }

  function pushHistory() {
    state.spacerNotice = null;
    state.history.push({
      slots: [...state.slots],
      groesse: state.groesse,
      spacerGaps: [...state.spacerGaps],
      freedSlots: [...(state.freedSlots || [])],
      selectedSpacerId: state.selectedSpacerId,
      activeSpacerId: state.activeSpacerId,
      spacerMode: state.spacerMode,
      hiddenEmptySlots: state.hiddenEmptySlots,
      closureBead: state.closureBead,
      spacerConflict: state.spacerConflict,
      spacerConflictCount: state.spacerConflictCount,
      spacerConflictContext: state.spacerConflictContext,
      spacerConflictCandidate: state.spacerConflictCandidate
        ? { gaps: [...state.spacerConflictCandidate.gaps], mode: state.spacerConflictCandidate.mode }
        : null
    });
    if (state.history.length > 50) state.history.shift();
  }

  function resetSlots() {

    state.spacerMode = 'none';
    state.spacerGaps = [];
    state.freedSlots = [];
    state.slots = Array.from({ length: getSlotCount() }, () => null);

    state.spacerConflict = false;
    state.spacerConflictCount = 0;
    state.spacerConflictContext = null;
    state.spacerConflictCandidate = null;
    state.conflictOverlayDismissed = false;
    state.hiddenEmptySlots = 0;
  }

  function removeSlotIndexes(indexes) {
    const sorted = [...indexes].sort((a, b) => b - a);
    if (!sorted.length) return;
    const oldLen = state.slots.length;
    if (state.spacerGaps.length) {
      state.spacerGaps = (state.hiddenEmptySlots || 0) > 0
        ? sorted.reduce((g, e, k) => remapGapsAfterRemoval(g, e, oldLen - 1 - k), state.spacerGaps)
        : reanchorGaps(state.spacerGaps, oldLen, sorted, oldLen - sorted.length);
    }
    sorted.forEach(index => state.slots.splice(index, 1));
    state.freedSlots = [];
  }

  function growSlotsTo(targetCount) {
    if (state.spacerGaps.length && (state.hiddenEmptySlots || 0) === 0) {
      state.spacerGaps = reanchorGaps(state.spacerGaps, state.slots.length, [], targetCount);
    }
    state.slots = Array.from({ length: targetCount }, (_, index) => state.slots[index] || null);
    state.freedSlots = [];
  }

  function adjustSlotsToSize() {
    const targetCount = getSlotCount();

    if (targetCount >= state.slots.length) {
      if (targetCount === state.slots.length || (state.hiddenEmptySlots || 0) > 0 || !applyRingRestructure(targetCount)) growSlotsTo(targetCount);
      state.spacerConflict = false;
      state.spacerConflictCount = 0;
      state.spacerConflictContext = null;
      state.spacerConflictCandidate = null;
      return;
    }

    const filledCount = state.slots.filter(Boolean).length;
    if (filledCount > targetCount) {
      state.spacerConflict = true;
      state.spacerConflictCount = filledCount - targetCount;
      state.spacerConflictContext = 'capacity';

      state.spacerConflictCandidate = { gaps: [...state.spacerGaps], mode: state.spacerMode };
      state.conflictOverlayDismissed = false;
      return;
    }

    const removeCount = state.slots.length - targetCount;
    if (!((state.hiddenEmptySlots || 0) === 0 && applyRingRestructure(targetCount))) {
      const removeIndexSet = new Set();
      for (let i = state.slots.length - 1; i >= 0 && removeIndexSet.size < removeCount; i--) {
        if (!state.slots[i]) removeIndexSet.add(i);
      }
      removeSlotIndexes(removeIndexSet);
    }

    state.hiddenEmptySlots = Math.max(0, (state.hiddenEmptySlots || 0) - removeCount);
    state.spacerConflict = false;
    state.spacerConflictCount = 0;
    state.spacerConflictContext = null;
    state.spacerConflictCandidate = null;
  }

  function normalizeSlotsToCapacity() {
    if (state.spacerConflict) return false;
    const target = getSlotCount();
    const before = state.slots.length + ':' + (state.hiddenEmptySlots || 0);
    if (state.slots.length !== target && (state.hiddenEmptySlots || 0) === 0 && applyRingRestructure(target)) {
      // Umbau ohne Neuzuordnung erledigt
    } else if (state.slots.length < target) {
      growSlotsTo(target);
    } else if (state.slots.length > target) {
      const surplusIndexes = new Set();
      const surplus = state.slots.length - target;
      for (let i = state.slots.length - 1; i >= 0 && surplusIndexes.size < surplus; i--) {
        if (!state.slots[i]) surplusIndexes.add(i);
      }
      removeSlotIndexes(surplusIndexes);
    }
    state.hiddenEmptySlots = 0;
    return before !== state.slots.length + ':0';
  }

  function renderAll() {
    renderGroessen();
    renderPerlen();
    renderPremiumKugelStep();
    renderSpacerStep();
    renderSlots();
    updatePriceAndSummary();
    updatePatternButtonLabel();
  }

  function renderGroessen() {
  wristRoot.innerHTML = state.groessen.map(item => `
    <button
      type="button"
      data-wrist-id="${item.id}"
      class="${state.groesse && item.key === state.groesse.key ? 'is-active' : ''}"
    >
      <strong>${item.groesse}</strong>
      <small>ca. ${item.cm} cm</small>
    </button>
  `).join('');
}

function perleImageUrl(perle) {
  if (!perle || !perle.bild_url) return '';

  let base = perle.bild_url.startsWith('http')
    ? perle.bild_url
    : SHOPIFY_FILE_BASE + perle.bild_url;

  if (perle.image_version) {
    base += (base.includes('?') ? '&' : '?') + 'v=' + perle.image_version;
  }

  return base;
}

function perleImageHtml(perle) {
  const url = perleImageUrl(perle);

  if (!url) {
    return `<span class="dyo-bead" style="--bead-bg:${beadGradient(perle)};"></span>`;
  }

  return `
    <span class="dyo-bead dyo-bead--image">
      <img src="${url}" alt="${perle.name}" loading="lazy" onerror="this.closest('.dyo-bead--image').outerHTML='<span class=\\'dyo-bead\\' style=\\'--bead-bg:${beadGradient(perle).replace(/'/g, "\\'")};\\'></span>'">
    </span>
  `;
}

function perleRingImageHtml(perle) {
  const url = perleImageUrl(perle);
  const finish = deriveBeadFinish(perle);
  const finishClass = finish !== 'glossy' ? ` dyo-bead--${finish}` : '';

  if (!url) {
    return `<span class="dyo-bead dyo-bead--ring${finishClass}" style="--bead-bg:${beadGradientRing(perle)};"><span class="dyo-bead__glint" aria-hidden="true"></span></span>`;
  }

  return `
    <span class="dyo-bead dyo-bead--image dyo-bead--ring${finishClass}">
      <img src="${url}" alt="${perle.name}" loading="lazy" onerror="this.closest('.dyo-bead--image').outerHTML='<span class=\\'dyo-bead dyo-bead--ring${finishClass}\\' style=\\'--bead-bg:${beadGradientRing(perle).replace(/'/g, "\\'")};\\'><span class=\\'dyo-bead__glint\\' aria-hidden=\\'true\\'></span></span>'">
      <span class="dyo-bead__glint" aria-hidden="true"></span>
    </span>
  `;
}

function customerFacingName(item) {
  const name = (item && item.name) || '';
  return item && item.contentType === 'premiumBead' ? name.replace(/^Premium-Kugel\b/i, 'Design-Kugel') : name;
}

function premiumKugelImageUrl(premiumKugel) {
  if (!premiumKugel || !premiumKugel.bild_url) return '';

  let base = premiumKugel.bild_url.startsWith('http')
    ? premiumKugel.bild_url
    : SHOPIFY_FILE_BASE + premiumKugel.bild_url;

  if (premiumKugel.image_version) {
    base += (base.includes('?') ? '&' : '?') + 'v=' + premiumKugel.image_version;
  }

  return base;
}

function premiumKugelImageHtml(premiumKugel) {
  const url = premiumKugelImageUrl(premiumKugel);

  if (!url) {
    return `<span class="dyo-bead dyo-bead--premium" aria-hidden="true"></span>`;
  }

  return `
    <span class="dyo-bead dyo-bead--premium">
      <img src="${url}" alt="${customerFacingName(premiumKugel)}" loading="lazy" onerror="this.closest('.dyo-bead--premium').innerHTML=''">
    </span>
  `;
}

function premiumKugelRingImageHtml(premiumKugel) {
  const url = premiumKugelImageUrl(premiumKugel);

  if (!url) {
    return `<span class="dyo-bead dyo-bead--premium" aria-hidden="true"></span>`;
  }

  return `
    <span class="dyo-bead dyo-bead--premium">
      <img src="${url}" alt="${customerFacingName(premiumKugel)}" loading="lazy" onerror="this.closest('.dyo-bead--premium').innerHTML=''">
    </span>
  `;
}

function slotContentRingHtml(slotContent) {
  if (!slotContent) return '';
  return slotContent.contentType === 'premiumBead'
    ? premiumKugelRingImageHtml(slotContent)
    : perleRingImageHtml(slotContent);
}

function spacerImageUrl(spacer) {
  if (!spacer || !spacer.bild_url) return '';

  let base = spacer.bild_url.startsWith('http')
    ? spacer.bild_url
    : SHOPIFY_FILE_BASE + spacer.bild_url;

  const hasVersionParam = /[?&]v=/.test(base);
  if (!hasVersionParam && spacer.image_version) {
    base += (base.includes('?') ? '&' : '?') + 'v=' + spacer.image_version;
  }

  return base;
}

function spacerRingImageUrl(spacer) {
  if (!spacer || !spacer.ring_bild_url) return '';

  let base = spacer.ring_bild_url.startsWith('http')
    ? spacer.ring_bild_url
    : SHOPIFY_FILE_BASE + spacer.ring_bild_url;

  const hasVersionParam = /[?&]v=/.test(base);
  if (!hasVersionParam && spacer.image_version) {
    base += (base.includes('?') ? '&' : '?') + 'v=' + spacer.image_version;
  }

  return base;
}

function spacerGradient(spacer) {
  const farbe = (spacer.farbe || '').toLowerCase();

  if (farbe.includes('weiß') || farbe.includes('weiss')) {
    return 'linear-gradient(135deg, #f4efe0 0%, #d8d2c4 35%, #f7f3e8 55%, #c9c2b0 100%)';
  }
  if (farbe.includes('gold')) {
    return 'linear-gradient(135deg, #fdeeb0 0%, #d4a94a 35%, #fff3c4 55%, #b8862f 100%)';
  }
  if (farbe.includes('silber')) {
    return 'linear-gradient(135deg, #f4f4f6 0%, #b7bac0 35%, #ffffff 55%, #9a9ea6 100%)';
  }

  return 'linear-gradient(135deg, #eeeeee 0%, #bbbbbb 50%, #eeeeee 100%)';
}

const SPACER_FILL_OVERRIDE = { 4: 0.76, 5: 1.82, 6: 1.72 };
const SPACER_IMAGE_FILL = {
  'Rondell_925_Sterling_Silber_konfi.png': 1.38,
  'Rondell_Gold_konfi.png': 1.38,
  'Polierter_Edelstahl-Abstandshalter.png': 1.38
};
function spacerImageFileName(spacer) {
  return String((spacer && spacer.bild_url) || '').split('?')[0].split('/').pop();
}
function deriveSpacerFillScale(spacer) {
  const KNOWN = { 4: 1.85, 5: 2.0, 6: 1.85 };
  const imageFill = SPACER_IMAGE_FILL[spacerImageFileName(spacer)];
  if (imageFill !== undefined) return imageFill;
  const override = SPACER_FILL_OVERRIDE[Number(spacer.id)];
  if (override !== undefined) return override;
  const n = Number(spacer.aussendurchmesser_mm);
  if (!n) return KNOWN[5];
  if (KNOWN[n] !== undefined) return KNOWN[n];
  return Math.max(1.6, Math.min(2.3, KNOWN[5] + (n - 5) * 0.15));
}

const SPACER_HOLE_MASK = { 3: { outer: 16, inner: 67 }, 6: { outer: 18, inner: 71 } };
function spacerHoleGradient(spacer, innerPercent) {
  const farbe = (spacer.farbe || '').toLowerCase();
  const stops = farbe.includes('gold')
    ? ['#d4a94a', '#fdeeb0', '#b8862f']
    : ['#b7bac0', '#f4f4f6', '#9a9ea6'];
  return `radial-gradient(circle, transparent ${innerPercent}%, ${stops[0]} ${innerPercent}%, ${stops[1]} 78%, ${stops[2]} 100%)`;
}
function spacerImageHtml(spacer) {
  const url = spacerImageUrl(spacer);

  if (!url) {
    return `<span class="dyo-bead" style="--bead-bg:${spacerGradient(spacer)};"></span>`;
  }

  const fillScale = deriveSpacerFillScale(spacer);
  const holeMask = SPACER_HOLE_MASK[Number(spacer.id)];
  const maskVars = holeMask ? ` --dyo-hole-outer:${holeMask.outer}px; --dyo-hole-grad:${spacerHoleGradient(spacer, holeMask.inner)};` : '';
  const maskClass = holeMask ? ' dyo-bead--spacer-masked' : '';

  return `
    <span class="dyo-bead dyo-bead--image dyo-bead--spacer${maskClass}" style="--dyo-spacer-fill:${fillScale};${maskVars}">
      <img src="${url}" alt="${spacer.name}" loading="lazy" onerror="this.closest('.dyo-bead--image').outerHTML='<span class=\\'dyo-bead\\' style=\\'--bead-bg:${spacerGradient(spacer).replace(/'/g, "\\'")};\\'></span>'">
    </span>
  `;
}

const RONDELL_925_SPACER_IDS = [8, 9];
function isRondell925(spacer) {
  return !!spacer && RONDELL_925_SPACER_IDS.includes(Number(spacer.id));
}

const SPACER_DISC_THICKNESS_BOOST = 1.5;

function spacerDiscWidth(spacer, slotSize) {
  const widthRatio = Number(spacer.dicke_mm || 1.2) / 6;
  return Math.max(5, Math.round(slotSize * widthRatio * SPACER_DISC_THICKNESS_BOOST));
}

function spacerDiscHtml(spacer, angleDeg, slotSize) {
  const heightRatio = Number(spacer.aussendurchmesser_mm || 6) / 6;
  const height = Math.round(slotSize * heightRatio);
  const width = spacerDiscWidth(spacer, slotSize);
  const rotation = angleDeg + 90;
  const safeName = (spacer.name || '').replace(/'/g, "\\'");
  const fallbackGradient = spacerDiscGradient(spacer).replace(/'/g, "\\'");
  const ringUrl = spacerRingImageUrl(spacer);

  if (ringUrl) {

    const extraClass = isRondell925(spacer) ? ' dyo-spacer-disc--rondell-925' : '';
    return `
      <span class="dyo-spacer-disc dyo-spacer-disc--asset${extraClass}"
        style="width:${width}px; height:${height}px; transform: rotate(${rotation}deg);"
        title="${spacer.name}"
        aria-hidden="true"><img src="${ringUrl}" alt="" loading="lazy" onerror="this.closest('.dyo-spacer-disc').outerHTML='<span class=\\'dyo-spacer-disc\\' style=\\'width:${width}px;height:${height}px;background:${fallbackGradient};transform:rotate(${rotation}deg);\\' title=\\'${safeName}\\' aria-hidden=\\'true\\'></span>'"></span>
    `;
  }

  return `
    <span class="dyo-spacer-disc"
      style="width:${width}px; height:${height}px; background:${spacerDiscGradient(spacer)}; transform: rotate(${rotation}deg);"
      title="${spacer.name}"
      aria-hidden="true"></span>
  `;
}

function spacerDiscGradient(spacer) {
  const farbe = (spacer.farbe || '').toLowerCase();

  if (farbe.includes('weiß') || farbe.includes('weiss')) {
    return 'linear-gradient(100deg, #a49b82 0%, #fdf9ee 12%, #fffef8 20%, #e2dbc6 38%, #a89f88 52%, #766e5a 62%, #d9d1ba 76%, #f7f1de 90%, #fffbef 100%)';
  }
  if (farbe.includes('gold')) {
    return 'linear-gradient(100deg, #6e4f16 0%, #ffe9a3 12%, #fff6d2 20%, #d9a53f 38%, #8b6b1f 52%, #5c4210 62%, #c98f2e 76%, #ffdf8a 90%, #fff3c4 100%)';
  }
  if (farbe.includes('silber')) {
    return 'linear-gradient(100deg, #5c5f66 0%, #ffffff 12%, #ffffff 20%, #d3d6db 38%, #8a8e96 52%, #55585e 62%, #b9bdc4 76%, #f4f5f7 90%, #ffffff 100%)';
  }

  return 'linear-gradient(100deg, #7d7d7d 0%, #fbfbfb 14%, #e6e6e6 32%, #a3a3a3 50%, #6b6b6b 62%, #cfcfcf 78%, #f5f5f5 92%, #ffffff 100%)';
}

function renderConflictOverlay() {
  const el = root.querySelector('[data-conflict-overlay]');
  if (!el) return;

  if (!state.spacerConflict) {
    state.conflictOverlayDismissed = false;
    if (state.spacerNotice) {
      el.hidden = false;
      el.innerHTML = `
        <button type="button" class="dyo-conflict-overlay__close" data-conflict-dismiss aria-label="Meldung schließen">×</button>
        <p class="dyo-conflict-overlay__title" role="status">${state.spacerNotice.text}</p>
        <p class="dyo-conflict-overlay__hint">Die Aktion wurde nicht ausgeführt. Nutze „Steine entfernen“ und klicke danach erneut.</p>
      `;
      return;
    }
    el.hidden = true;
    el.innerHTML = '';
    return;
  }

  if (state.conflictOverlayDismissed) {
    el.hidden = true;
    el.innerHTML = '';
    return;
  }

  const n = state.spacerConflictCount;

  const steinLabel = n === 1 ? '1 Stein' : `${n} Steine`;
  let title;
  if (state.spacerConflictContext === 'capacity') {
    title = `Für diese Konfiguration sind weniger Plätze vorgesehen. Entferne ${steinLabel}.`;
  } else if (state.spacerConflictContext === 'all') {
    title = `Entferne ${steinLabel}, um „Zwischen allen" zu verwenden.`;
  } else if (state.spacerConflictContext === 'manual') {
    title = `Entferne ${steinLabel}, um diesen Spacer zu platzieren.`;
  } else {
    title = `Entferne ${steinLabel}, um Platz für die gewählten Spacer zu schaffen.`;
  }

  el.hidden = false;
  el.innerHTML = `
    <button type="button" class="dyo-conflict-overlay__close" data-conflict-dismiss aria-label="Meldung schließen">×</button>
    <p class="dyo-conflict-overlay__title">${title}</p>
    <p class="dyo-conflict-overlay__hint">Entferne einzelne Steine oder reduziere die Spacer-Anzahl.</p>
  `;
}

function renderPerlen() {
  const stoneGrid = root.querySelector('[data-stone-grid]');
  if (!stoneGrid) return;

  const filtered = state.perlen.filter(perle => {
    const preisgruppe = (perle.preisgruppe || 'standard').toLowerCase();
    if (state.stoneFilter === 'standard') return preisgruppe !== 'premium';
    if (state.stoneFilter === 'premium') return preisgruppe === 'premium';
    return true;
  });

  const sorted = [...filtered].sort((a, b) => {
    const rankA = (a.preisgruppe || '').toLowerCase() === 'premium' ? 0 : 1;
    const rankB = (b.preisgruppe || '').toLowerCase() === 'premium' ? 0 : 1;
    return rankA - rankB;
  });

  stoneGrid.innerHTML = sorted.map(perle => {
    const preisgruppe = (perle.preisgruppe || 'standard').toLowerCase();
    const badgeLabel = preisgruppe === 'premium' ? 'Premium' : 'Standard';
    const cleanName = perle.name.replace(/\s*\d+\s*mm\s*/gi, '');
    const sizeMmValue = Number(perle.groesse_mm) || BEAD_DIAMETER_MM;
    const sizeLabel = `${sizeMmValue} mm`;
    const bedeutungRaw = perle.hauptbedeutung || '';
    const bedeutungHasSize = /\d+\s*mm/i.test(bedeutungRaw);
    const sizeSuffix = bedeutungHasSize ? '' : ` <span class="dyo-stone-size">· ${sizeLabel}</span>`;
    const hauptbedeutung = bedeutungRaw
      ? `<small class="dyo-stone-bedeutung">${bedeutungRaw}${sizeSuffix}</small>`
      : `<small class="dyo-stone-bedeutung"><span class="dyo-stone-size">${sizeLabel}</span></small>`;
    return `
      <button type="button" class="dyo-stone-card ${Number(perle.id) === Number(state.selectedPerleId) ? 'is-selected' : ''}" data-perle-id="${perle.id}">
        ${perleImageHtml(perle)}
        <span class="dyo-stone-info">
          <strong>${cleanName}</strong>
          ${hauptbedeutung}
        </span>
        <span class="dyo-stone-badge dyo-stone-badge--${preisgruppe}">${badgeLabel}</span>
      </button>
    `;
  }).join('');
}

const PREMIUM_KUGEL_LABELS = {
  3: { title: 'Goldkugel – glatt', sub: '14K PVD-vergoldet · 6 mm' },
  4: { title: 'Edelstahlkugel – poliert', sub: '6 mm' },
  5: { title: 'Silberkugel – strukturiert', sub: '925 Sterling Silber · 6 mm' },
  6: { title: 'Diamantierte Silberkugel', sub: '925 Sterling Silber · 6 mm' }
};

function derivePremiumKugelLabel(kugel) {
  const known = PREMIUM_KUGEL_LABELS[Number(kugel.id)];
  if (known) return known;
  const sizeLabel = kugel.groesse_mm ? `${Number(kugel.groesse_mm)} mm` : '';
  const oberflaeche = (kugel.oberflaeche || '').split('/')[0].trim();
  const title = [kugel.material, oberflaeche].filter(Boolean).join(' – ') || kugel.name;
  return { title, sub: sizeLabel };
}

function renderPremiumKugelStep() {
  const grid = root.querySelector('[data-premium-kugel-grid]');
  if (!grid) return;

  if (!state.premiumKugeln.length) {
    grid.innerHTML = '<p class="dyo-help dyo-spacer-empty">Aktuell sind noch keine Design-Kugeln verfügbar.</p>';
    return;
  }

  const filtered = state.premiumKugeln.filter(kugel => {
    const farbe = (kugel.farbe || '').toLowerCase();
    if (state.premiumColorFilter === 'gold') return farbe.includes('gold');
    if (state.premiumColorFilter === 'silber') return farbe.includes('silber');
    return true;
  });

  grid.innerHTML = filtered.map(kugel => {
    const isSelected = state.activeSelectionType === 'premiumBead'
      && Number(kugel.id) === Number(state.selectedPremiumKugelId);
    const { title, sub } = derivePremiumKugelLabel(kugel);
    const subLine = sub ? `<small class="dyo-stone-bedeutung">${sub}</small>` : '';

    return `
      <button type="button" class="dyo-stone-card ${isSelected ? 'is-selected' : ''}" data-premium-kugel-id="${kugel.id}">
        ${premiumKugelImageHtml(kugel)}
        <span class="dyo-stone-info">
          <strong>${title}</strong>
          ${subLine}
        </span>
      </button>
    `;
  }).join('');
}

  function normalizeMaterialLabel(raw) {
    let text = (raw || '').trim();
    if (!text) return '';

    text = text.replace(/\bspacer\b/gi, '').replace(/\s+/g, ' ').trim();
    if (!text) return '';

    const karatMatch = text.match(/\b(\d{1,2}\s?k|925|750|585|333)\b/i);
    const karatPrefix = karatMatch ? karatMatch[0].replace(/\s+/g, '').toUpperCase() : '';

    const farbeMatch = text.match(/(wei[ßs]s?)?-?(silber|gold|rosé?gold|platin|kupfer)\w*?(farben|farbig|farbe)\w*/i);
    if (farbeMatch) {
      const tonRaw = ((farbeMatch[1] || '') + (farbeMatch[2] || '')).toLowerCase().replace(/weiss/, 'weiß');
      const tonLabel = tonRaw.charAt(0).toUpperCase() + tonRaw.slice(1);
      return karatPrefix ? `${karatPrefix}-${tonRaw}farben` : `${tonLabel}farben`;
    }

    return text.replace(/^,+|,+$/g, '').trim();
  }

  function updateManualPreviewToggle() {
    if (!manualPreviewToggleBtn) return;
    const active = state.spacerMode === 'manual';
    manualPreviewToggleBtn.hidden = !active;
    if (!active) return;
    const previewing = state.manualPreviewMode;
    manualPreviewToggleBtn.setAttribute('aria-pressed', String(previewing));
    const label = previewing ? 'Spacer weiter bearbeiten' : 'Armband ohne Bearbeitungshilfen ansehen';
    manualPreviewToggleBtn.setAttribute('aria-label', label);
    manualPreviewToggleBtn.setAttribute('title', label);
    manualPreviewToggleBtn.classList.toggle('is-previewing', previewing);
    const labelEl = manualPreviewToggleBtn.querySelector('[data-manual-preview-toggle-label]');
    if (labelEl) labelEl.textContent = previewing ? 'Bearbeiten' : 'Vorschau';
  }

  function spacerGroupTextField(text) {
    return (text || '')
      .replace(/\bspacer\b/gi, '')
      .replace(/\brondell\b/gi, '')
      .replace(/\d+([.,]\d+)?\s*mm\b/gi, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function getSpacerGroupKey(spacer) {
    const typ = deriveSpacerTyp(spacer.name);
    const farbeKey = spacerGroupTextField(spacer.farbe);
    const materialKey = spacerGroupTextField(spacer.material);
    return [typ, farbeKey, materialKey].join('::');
  }

  function groupSpacersForDisplay(spacerList) {
    const groups = [];
    const groupsByKey = new Map();

    spacerList.forEach(spacer => {
      const key = getSpacerGroupKey(spacer);
      const sizeMm = spacer.aussendurchmesser_mm ? Number(spacer.aussendurchmesser_mm) : null;
      let group = groupsByKey.get(key);
      if (!group) {
        group = { key, typLabel: deriveSpacerTyp(spacer.name), items: [] };
        groupsByKey.set(key, group);
        groups.push(group);
      }
      group.items.push({ spacer, sizeMm });
    });

    groups.forEach(group => {
      group.items.sort((a, b) => (a.sizeMm || 0) - (b.sizeMm || 0));
      const bySize = new Map(group.items.filter(it => it.sizeMm !== null).map(it => [it.sizeMm, it.spacer]));
      const maxSize = group.items.length ? group.items[group.items.length - 1].sizeMm : null;
      const firstWithImage = group.items.find(it => !!spacerImageUrl(it.spacer));
      group.representative =
        bySize.get(6) ||
        (maxSize !== null ? bySize.get(maxSize) : null) ||
        (firstWithImage && firstWithImage.spacer) ||
        group.items[0].spacer;
    });

    return groups;
  }

  function renderSpacerStep() {
    if (!spacerStepRoot) return;

    const previousGrid = spacerStepRoot.querySelector('[data-spacer-grid]');
    const preservedScrollTop = previousGrid ? previousGrid.scrollTop : 0;

    if (!state.spacer.length) {
      spacerStepRoot.innerHTML = '<p class="dyo-help dyo-spacer-empty">Aktuell sind noch keine Spacer verfügbar.</p>';
      updateManualPreviewToggle();
      return;
    }

    const cardsHtml = groupSpacersForDisplay(state.spacer).map(group => {
      const isGroupSelected = group.items.some(item => Number(item.spacer.id) === Number(state.selectedSpacerId));
      const representative = group.representative;

      const materialRaw = (representative.material || '').trim()
        || (representative.name || '')
          .replace(/^Spacer\s*/i, '')
          .replace(/\s*\d+([.,]\d+)?\s*mm\s*$/i, '')
          .trim()
        || representative.farbe || '';
      const materialLabel = normalizeMaterialLabel(materialRaw);

      const sizeButtonsHtml = group.items.map(item => {
        const isSizeActive = Number(item.spacer.id) === Number(state.selectedSpacerId);
        const sizeLabel = item.sizeMm ? `${item.sizeMm} mm` : (item.spacer.name || 'Größe');
        return `<button type="button" class="dyo-spacer-size-btn ${isSizeActive ? 'is-active' : ''}" data-spacer-id="${item.spacer.id}">${sizeLabel}</button>`;
      }).join('');

      return `
        <div class="dyo-stone-card dyo-stone-card--group ${isGroupSelected ? 'is-selected' : ''}">
          ${spacerImageHtml(representative)}
          <span class="dyo-stone-info">
            <strong>${group.typLabel}</strong>
            ${materialLabel ? `<small>${materialLabel}</small>` : ''}
          </span>
          <div class="dyo-spacer-size-group" role="group" aria-label="Größe wählen">${sizeButtonsHtml}</div>
        </div>
      `;
    }).join('');

    const needsModeChoice = state.spacerMode === 'none' && !!state.selectedSpacerId;

    const modes = [
      { mode: 'none', label: 'Ohne' },
      { mode: 'manual', label: 'Manuell' },
      { mode: 'all', label: 'Zwischen allen' }
    ].map(m => {
      const cls = [
        state.spacerMode === m.mode ? 'is-active' : '',
        needsModeChoice && m.mode !== 'none' ? 'dyo-spacer-mode-highlight' : ''
      ].filter(Boolean).join(' ');
      return `<button type="button" class="${cls}" data-spacer-mode="${m.mode}">${m.label}</button>`;
    }).join('');

    const hint = (state.spacerMode === 'manual' || state.spacerMode === 'all') && !state.activeSpacerId
      ? `<p class="dyo-help" data-spacer-select-hint>Wähle einen Spacer, um ihn zu verwenden.</p>`
      : '';

    const inactiveHint = needsModeChoice
      ? '<p class="dyo-help dyo-spacer-inactive-hint">Wähle „Manuell“ oder „Zwischen allen“, um den Spacer zu platzieren.</p>'
      : '';

    spacerStepRoot.innerHTML = `
      <div class="dyo-segmented" data-spacer-mode-group>${modes}</div>
      ${hint}
      ${inactiveHint}
      <div class="dyo-list-head">
        <span></span><span>Element</span><span>Ausführung</span>
      </div>
      <div class="dyo-stone-grid dyo-stone-grid--list ${state.spacerMode === 'none' ? 'dyo-spacer-grid--inactive' : ''}" data-spacer-grid>${cardsHtml}</div>
    `;

    const nextGrid = spacerStepRoot.querySelector('[data-spacer-grid]');
    if (nextGrid) nextGrid.scrollTop = preservedScrollTop;

    updateManualPreviewToggle();
  }

  function deriveSpacerTyp(name) {
    const n = (name || '').toLowerCase();
    if (n.includes('rondell')) return 'Rondell';
    if (n.includes('kugel')) return 'Kugel';
    if (n.includes('spacer')) return 'Spacer';
    return 'Element';
  }

  function getHiddenEmptySlotIndexes(count) {
    const hidden = new Set();
    let toHide = Math.max(0, state.hiddenEmptySlots || 0);
    for (let i = count - 1; i >= 0 && toHide > 0; i--) {
      if (!state.slots[i]) {
        hidden.add(i);
        toHide--;
      }
    }
    return hidden;
  }

  function getVisibleStoneIndexes(count) {
    const hidden = getHiddenEmptySlotIndexes(count);
    const visible = [];
    for (let i = 0; i < count; i++) {
      if (!hidden.has(i)) visible.push(i);
    }
    return visible;
  }

  function getClosurePrecedingStone(count) {
    const visible = getVisibleStoneIndexes(count);
    if (!visible.length) return null;
    return visible[Math.ceil(visible.length / 2) - 1];
  }

  function mergeClosureNeighbourGap(count) {
    if (state.spacerMode !== 'manual' || !state.spacerGaps.length) return;
    const preceding = getClosurePrecedingStone(count);
    if (preceding === null || !state.spacerGaps.includes(preceding)) return;
    state.spacerGaps = [...new Set(state.spacerGaps.map(g => (g === preceding ? CLOSURE_GAP_RIGHT : g)))];
  }

  function buildVisualSequence(count) {
    const selected = getActiveSpacer();
    const visible = getVisibleStoneIndexes(count);
    if (!visible.length) return [];
    const preceding = getClosurePrecedingStone(count);
    const spacerAt = id => !!selected && (
      state.spacerMode === 'all' ||
      (state.spacerMode === 'manual' && state.spacerGaps.includes(id))
    );
    const seq = [];
    visible.forEach(i => {
      seq.push({ type: 'stone', slotIndex: i });
      if (i === preceding) {
        if (spacerAt(CLOSURE_GAP_RIGHT)) seq.push({ type: 'spacer', gapIndex: CLOSURE_GAP_RIGHT, spacer: selected });
        seq.push({ type: 'closure' });
        if (spacerAt(CLOSURE_GAP_LEFT)) seq.push({ type: 'spacer', gapIndex: CLOSURE_GAP_LEFT, spacer: selected });
      } else if (spacerAt(i)) {
        seq.push({ type: 'spacer', gapIndex: i, spacer: selected });
      }
    });
    return seq;
  }

  function computeRingLayout(count, radius, slotSize) {
    if (count <= 0) return { stoneAngles: [], gapAngles: {}, spacerAngles: {}, hiddenSlotIndexes: new Set(), closureAngle: 90 };

    const seq = buildVisualSequence(count);
    const hiddenSlotIndexes = getHiddenEmptySlotIndexes(count);
    if (seq.length === 0) {
      return { stoneAngles: new Array(count).fill(null), gapAngles: {}, spacerAngles: {}, hiddenSlotIndexes, closureAngle: 90 };
    }
    const preceding = getClosurePrecedingStone(count);
    const n = seq.length;
    const OVERLAP_PX = 0.75;

    const OVERLAP_PX_RONDELL_925 = 0.35;

    const widths = seq.map(el => {
      if (el.type === 'stone') return slotSize;
      if (el.type === 'closure') return closureWidthPx(slotSize);
      return spacerDiscWidth(el.spacer, slotSize);
    });

    const junctionGap = new Array(n);
    const closureJunctions = new Array(n).fill(false);
    let stoneStoneJunctions = 0;
    for (let j = 0; j < n; j++) {
      const a = seq[j];
      const b = seq[(j + 1) % n];
      if (a.type === 'closure' || b.type === 'closure') {
        junctionGap[j] = 1.5;
        closureJunctions[j] = true;
      } else if (a.type === 'spacer' || b.type === 'spacer') {
        const touchesRondell925 =
          (a.type === 'spacer' && isRondell925(a.spacer)) ||
          (b.type === 'spacer' && isRondell925(b.spacer));
        junctionGap[j] = touchesRondell925 ? -OVERLAP_PX_RONDELL_925 : -OVERLAP_PX;
      } else {
        junctionGap[j] = 0;
        stoneStoneJunctions++;
      }
    }

    const circumference = 2 * Math.PI * radius;
    const sumWidths = widths.reduce((sum, w) => sum + w, 0);
    const sumJunctions = junctionGap.reduce((sum, g) => sum + g, 0);
    const residual = circumference - sumWidths - sumJunctions;

    if (residual >= 0 && stoneStoneJunctions > 0) {
      const share = residual / stoneStoneJunctions;
      for (let j = 0; j < n; j++) {
        if (junctionGap[j] === 0) junctionGap[j] = share;
      }
    } else {
      const flexibleJunctions = closureJunctions.filter(isFixed => !isFixed).length || 1;
      const share = residual / flexibleJunctions;
      for (let j = 0; j < n; j++) {
        if (!closureJunctions[j]) junctionGap[j] += share;
      }
    }

    const pxToDeg = px => (px / radius) * (180 / Math.PI);

    const stoneAngles = new Array(count).fill(null);
    const spacerAngles = {};
    const gapAngles = {};
    let cursorDeg = -90;
    let closureAngleRaw = 90;
    const plusDiameter = Math.max(15, Math.min(19, slotSize * 0.46));
    const closureHitboxOffsetDeg = pxToDeg(plusDiameter / 2 - 0.25);
    for (let k = 0; k < n; k++) {
      const el = seq[k];
      if (el.type === 'stone') {
        stoneAngles[el.slotIndex] = cursorDeg;

        const junctionMidDeg = cursorDeg + pxToDeg(widths[k] / 2 + junctionGap[k] / 2);
        if (el.slotIndex === preceding) {
          gapAngles[CLOSURE_GAP_RIGHT] = junctionMidDeg - closureHitboxOffsetDeg;
        } else {
          gapAngles[el.slotIndex] = junctionMidDeg;
        }
      } else if (el.type === 'spacer') {
        spacerAngles[el.gapIndex] = cursorDeg;
      } else {
        closureAngleRaw = cursorDeg;
        gapAngles[CLOSURE_GAP_LEFT] = cursorDeg + pxToDeg(widths[k] / 2 + junctionGap[k] / 2) + closureHitboxOffsetDeg;
      }
      const next = (k + 1) % n;
      cursorDeg += pxToDeg(widths[k] / 2 + junctionGap[k] + widths[next] / 2);
    }

    Object.keys(spacerAngles).forEach(gapIndex => {
      gapAngles[gapIndex] = spacerAngles[gapIndex];
    });

    const closureAngle = 90;
    const rotationDeg = closureAngle - closureAngleRaw;
    for (let i = 0; i < stoneAngles.length; i++) {
      if (stoneAngles[i] !== null) stoneAngles[i] += rotationDeg;
    }
    Object.keys(gapAngles).forEach(key => { gapAngles[key] += rotationDeg; });
    Object.keys(spacerAngles).forEach(key => { spacerAngles[key] += rotationDeg; });

    return { stoneAngles, gapAngles, spacerAngles, hiddenSlotIndexes, closureAngle };
  }

  function renderSpacerVisualsHtml(radius, center, slotSize, spacerAngles) {
    const selectedSpacer = getActiveSpacer();
    if (!selectedSpacer || state.spacerMode === 'none') return '';

    const wrapperExtraClass = isRondell925(selectedSpacer) ? ' dyo-ring-spacer--rondell-925' : '';

    let html = '';
    Object.keys(spacerAngles).forEach(gapIndex => {
      const angle = spacerAngles[gapIndex];
      const rad = angle * Math.PI / 180;
      const x = center + radius * Math.cos(rad);
      const y = center + radius * Math.sin(rad);
      html += `
        <div class="dyo-ring-spacer${wrapperExtraClass}"
          style="left:${x}px; top:${y}px;"
          aria-hidden="true">
          ${spacerDiscHtml(selectedSpacer, angle, slotSize)}
        </div>
      `;
    });
    return html;
  }

  function renderGapHitboxesHtml(count, radius, center, slotSize, gapAngles) {
    if (state.spacerMode !== 'manual' || count === 0) return '';

    let html = '';
    Object.keys(gapAngles).forEach(key => {
      const i = parseGapId(key);
      const isClosureGap = CLOSURE_GAP_IDS.includes(i);
      const angle = gapAngles[key];
      const rad = angle * Math.PI / 180;
      const x = center + radius * Math.cos(rad);
      const y = center + radius * Math.sin(rad);
      const isFilled = state.spacerGaps.includes(i);

      const gapRemoveOffset = slotSize * 0.55;
      const gapRemoveDx = isFilled ? Math.cos(rad) * gapRemoveOffset : 0;
      const gapRemoveDy = isFilled ? Math.sin(rad) * gapRemoveOffset : 0;

      const gapLabel = isClosureGap
        ? `Spacer ${i === CLOSURE_GAP_LEFT ? 'links' : 'rechts'} neben dem Verschluss`
        : `Spacer nach Stein ${i + 1}`;

      html += `
        <button type="button"
          class="dyo-gap ${isFilled ? 'is-filled' : ''} ${isClosureGap ? 'dyo-gap--closure' : ''}"
          style="left:${x}px; top:${y}px; --slot-size:${slotSize}px; --gap-remove-dx:${gapRemoveDx}px; --gap-remove-dy:${gapRemoveDy}px;"
          data-gap="${i}"
          aria-label="${isFilled ? `${gapLabel} entfernen` : `${gapLabel} platzieren`}">
          ${isFilled
            ? '<span class="dyo-gap__remove" aria-hidden="true">×</span>'
            : '<span class="dyo-gap__plus" aria-hidden="true">+</span>'}
        </button>
      `;
    });

    return html;
  }

  function renderSlots() {
    const targetCount = getSlotCount();

    if (state.slots.length !== targetCount) {
      adjustSlotsToSize();
    }

    const count = state.slots.length;

    const baseSlotCount = getBaseSlotCount(state.groesse ? state.groesse.key : null);

    const stageSize = stage.clientWidth;
    const slotSize = Math.max(22, Math.min(38, stageSize / 13));

    const naturalRadius = (slotSize * baseSlotCount) / (2 * Math.PI) * 0.98;
    const maxRadius = (stageSize / 2) - (slotSize / 2) - 10;
    const finalRadius = Math.min(naturalRadius, maxRadius);

    const center = stageSize / 2;
    let html = '';

    slotRoot.classList.toggle('is-delete-mode', state.deleteMode);
    slotRoot.classList.toggle('dyo-manual-preview', state.manualPreviewMode);

    mergeClosureNeighbourGap(count);

    const { stoneAngles, gapAngles, spacerAngles, closureAngle } = computeRingLayout(count, finalRadius, slotSize);

    for (let i = 0; i < count; i++) {
      const angle = stoneAngles[i];

      if (angle === null) continue;
      const rad = angle * Math.PI / 180;
      const x = center + finalRadius * Math.cos(rad);
      const y = center + finalRadius * Math.sin(rad);
      const perle = state.slots[i];

      const removeOffset = slotSize * 0.55;
      const removeDx = Math.cos(rad) * removeOffset;
      const removeDy = Math.sin(rad) * removeOffset;

      html += `
        <div class="dyo-slot-wrap ${perle ? 'is-filled' : ''}"
          data-slot-index="${i}"
          data-angle="${angle}"
          data-stone-id="${perle ? perle.id : ''}"
          style="left:${x}px; top:${y}px; --slot-size:${slotSize}px;">
          <span class="dyo-slot-visual ${perle ? 'is-filled' : ''}" aria-hidden="true">
            ${slotContentRingHtml(perle)}
          </span>
          <button type="button"
            class="dyo-slot ${perle ? 'is-filled' : ''}"
            data-slot="${i}"
            aria-label="Platz ${i + 1}${perle ? ' – ' + customerFacingName(perle) + ', zum Austauschen antippen' : ' – leer'}"></button>
          ${perle ? `
            <button type="button"
              class="dyo-slot-remove"
              data-remove-slot="${i}"
              style="--remove-dx:${removeDx}px; --remove-dy:${removeDy}px;"
              aria-label="Naturstein an Platz ${i + 1} entfernen">×</button>
          ` : ''}
        </div>
      `;
    }

    html += renderSpacerVisualsHtml(finalRadius, center, slotSize, spacerAngles);
    html += renderGapHitboxesHtml(count, finalRadius, center, slotSize, gapAngles);

    const closureRad = closureAngle * Math.PI / 180;
    const closureSize = closureWidthPx(slotSize);
    const closureFinish = state.closureBead === 'gold' ? 'gold' : 'silver';
    preloadClosureImages();
    const closureImageUrl = getClosureImageUrl(closureFinish);
    html += `
      <div class="dyo-ring-closure"
        data-ring-closure
        data-finish="${closureFinish}"
        data-image="${closureImageUrl ? 'true' : 'false'}"
        style="left:${center + finalRadius * Math.cos(closureRad)}px; top:${center + finalRadius * Math.sin(closureRad)}px; width:${closureSize}px; height:${closureSize}px;"
        aria-hidden="true">${closureImageUrl ? `<img class="dyo-ring-closure__image" src="${closureImageUrl}" alt="" loading="eager" decoding="async">` : ''}</div>
    `;

    slotRoot.innerHTML = html;
    slotRoot.querySelectorAll('.dyo-ring-closure__image').forEach(bindClosureImageFallback);
    renderConflictOverlay();
  }

  function syncSlotVisuals() {
    let changed = 0;
    const wraps = slotRoot.querySelectorAll('.dyo-slot-wrap[data-slot-index]');
    wraps.forEach(wrap => {
      const i = Number(wrap.dataset.slotIndex);
      const perle = state.slots[i];
      const nextId = perle ? String(perle.id) : '';
      if (wrap.dataset.stoneId === nextId) return;

      changed++;
      wrap.dataset.stoneId = nextId;
      wrap.classList.toggle('is-filled', !!perle);

      const visual = wrap.querySelector('.dyo-slot-visual');
      if (visual) {
        visual.classList.toggle('is-filled', !!perle);
        visual.innerHTML = slotContentRingHtml(perle);
      }

      const slotBtn = wrap.querySelector('.dyo-slot');
      if (slotBtn) {
        slotBtn.classList.toggle('is-filled', !!perle);
        slotBtn.setAttribute(
          'aria-label',
          `Position ${i + 1}${perle ? ' – ' + customerFacingName(perle) + ', zum Austauschen antippen' : ' – leer'}`
        );
      }

      let removeBtn = wrap.querySelector('.dyo-slot-remove');
      if (perle) {
        const slotSize = parseFloat(wrap.style.getPropertyValue('--slot-size')) || 0;
        const angle = Number(wrap.dataset.angle) || 0;
        const rad = angle * Math.PI / 180;
        const removeOffset = slotSize * 0.55;
        const removeDx = Math.cos(rad) * removeOffset;
        const removeDy = Math.sin(rad) * removeOffset;
        if (!removeBtn) {
          removeBtn = document.createElement('button');
          removeBtn.type = 'button';
          removeBtn.className = 'dyo-slot-remove';
          removeBtn.textContent = '×';
          wrap.appendChild(removeBtn);
        }
        removeBtn.dataset.removeSlot = String(i);
        removeBtn.style.setProperty('--remove-dx', `${removeDx}px`);
        removeBtn.style.setProperty('--remove-dy', `${removeDy}px`);
        removeBtn.setAttribute('aria-label', `Naturstein an Position ${i + 1} entfernen`);
      } else if (removeBtn) {
        removeBtn.remove();
      }
    });
    return changed;
  }

  function updateSlotVisuals() {
    const targetCount = getSlotCount();
    if (state.slots.length !== targetCount) {
      renderSlots();
      return;
    }
    syncSlotVisuals();
    renderConflictOverlay();
  }

  function updatePriceAndSummary() {
    reevaluateSpacerConflict();
    if (normalizeSlotsToCapacity()) {
      sendDiagnostic('selfheal_slots');
      renderSlots();
    }
    renderConflictOverlay();

    const priced = DyoEngine.pricing(buildEngineConfig(), getBasispreis());
    state.perlenAufpreis = DyoEngine.fromCents(priced.stonesCents);
    state.spacerAufpreis = DyoEngine.fromCents(priced.spacerCents);

    state.totalPreis = DyoEngine.fromCents(priced.totalCents);
    const filled = state.slots.filter(Boolean).length;
    const count = getSlotCount();
    const spacerCount = getSpacerCount();

    const groesseLabel = state.groesse ? state.groesse.groesse : '-';

    totalEl.textContent = money(state.totalPreis);

    const slotSummary = `${filled} / ${count} Plätze`;
    const summaryText = spacerCount > 0 ? `${slotSummary} · ${spacerCount} Spacer` : slotSummary;

    summaryEl.innerHTML = `
      <span>${groesseLabel}</span>
      <span>6 mm</span>
      <span>${summaryText}</span>
    `;

    if (mobilePriceEl) mobilePriceEl.textContent = money(state.totalPreis);
    if (mobileMetaEl) mobileMetaEl.textContent = `${groesseLabel} · 6 mm`;
    if (mobileSlotsEl) {
      mobileSlotsEl.textContent = spacerCount > 0
        ? `· ${filled} / ${count} Plätze · ${spacerCount} Spacer`
        : `· ${filled} / ${count} Plätze`;
    }

    const orderability = getOrderability();
    addBtn.disabled = !orderability.orderable || cartRequestBusy;
    renderCartReason(orderability);
    syncMobileCartSlider();
    undoBtn.disabled = state.history.length === 0;
    checkInvariants();
  }

  function syncMobileCartSlider() {
    if (!mobileCartSlider || !mobileCartHandle) return;
    if (mobileCartSliderBusy) return;
    const check = getOrderability();
    const ready = check.orderable;
    mobileCartSlider.dataset.disabled = ready ? 'false' : 'true';
    mobileCartHandle.disabled = !ready;
    mobileCartSlider.title = ready ? '' : check.reasons[0].text;
    if (mobileCartLabel) {
      mobileCartLabel.textContent = ready ? MOBILE_CART_LABEL : (check.reasons[0].short || MOBILE_CART_LABEL);
    }
  }

  function setSlot(index, perle) {
    pushHistory();
    state.slots[index] = perle;

    updateSlotVisuals();
    updatePriceAndSummary();
  }

  function buildBedeutungsprofil() {
    const profil = {};
    let total = 0;
    state.slots.forEach(perle => {
      if (!perle || perle.contentType === 'premiumBead') return;
      total++;
      const klasse = state.bedeutungsklassen.find(
        k => Number(k.id) === Number(perle.bedeutungsklasse_id)
      );
      const key = klasse?.name || 'Weitere Steine';
      profil[key] = (profil[key] || 0) + 1;
    });
    if (total === 0) return {};
    const result = {};
    Object.keys(profil).forEach(k => {
      result[k] = Math.round(profil[k] / total * 100) + ' %';
    });
    return result;
  }

  function buildSteineText() {
    const counts = {};
    state.slots.forEach(item => {
      if (!item) return;
      const cleanName = customerFacingName(item).replace(/\s*\d+\s*mm\s*/gi, '').trim();
      const label = item.contentType === 'premiumBead'
        ? (/^Design-Kugel\b/.test(cleanName) ? cleanName : `Design-Kugel: ${cleanName}`)
        : cleanName;
      const key = `${item.contentType || 'naturalStone'}::${label}`;
      counts[key] = counts[key] || { label, n: 0 };
      counts[key].n++;
    });
    return Object.values(counts)
      .sort((a, b) => b.n - a.n)
      .map(({ label, n }) => `${label} × ${n}`)
      .join(', ');
  }

  function buildSpacerDesignInfo() {
    const selected = getActiveSpacer();
    const count = getSpacerCount();

    if (state.spacerMode === 'none' || !selected || count === 0) {
      return { mode: 'none', count: 0 };
    }

    const aufpreisProSpacer = Number(selected.aufpreis || 0);
    const info = {
      id: selected.id,
      name: selected.name,
      farbe: selected.farbe || null,
      aussendurchmesser_mm: selected.aussendurchmesser_mm ?? null,
      dicke_mm: selected.dicke_mm ?? null,
      material: selected.material || null,
      mode: state.spacerMode,
      count,
      aufpreis_pro_spacer: aufpreisProSpacer,
      spacer_aufpreis_gesamt: Number((count * aufpreisProSpacer).toFixed(2))
    };

    if (state.spacerMode === 'manual') {
      info.gaps = [...state.spacerGaps];
    }

    return info;
  }

  function buildDesignJson() {
    const counts = {};
    state.slots.forEach(perle => {
      if (!perle || perle.contentType === 'premiumBead') return;
      const key = perle.id;
      if (!counts[key]) {
        counts[key] = {
          id: perle.id,
          name: perle.name.replace(/\s*\d+\s*mm\s*/gi, '').trim(),
          anzahl: 0,
          bedeutungsklasse_id: perle.bedeutungsklasse_id || null
        };
      }
      counts[key].anzahl++;
    });
    return JSON.stringify({
      version: 2,
      armband: {
        groesse: state.groesse?.key || '-',
        slotCount: window.DyoEngine.baseSlotCount(state.groesse?.key),
        kugel_mm: 6
      },
      closure_bead: {
        finish: CLOSURE_BEAD_OPTIONS[state.closureBead] ? state.closureBead : CLOSURE_BEAD_DEFAULT,
        size_mm: CLOSURE_BEAD_SIZE_MM
      },
      steine: Object.values(counts),
      slots: state.slots.map(item => {
        if (!item) return null;
        if (item.contentType === 'premiumBead') {
          return {
            contentType: 'premiumBead',
            id: item.id,
            name: item.name,
            farbe: item.farbe || null,
            material: item.material || null,
            beschichtung: item.beschichtung || null,
            beschichtungsverfahren: item.beschichtungsverfahren || null,
            aufpreis: item.aufpreis || 0,
            bild_url: premiumKugelImageUrl(item) || null,
            image_version: item.image_version || null
          };
        }
        return {
          contentType: 'naturalStone',
          id: item.id,
          name: item.name,
          farbe: item.farbe || null,
          aufpreis: item.aufpreis || 0,
          bedeutungsklasse_id: item.bedeutungsklasse_id || null,
          bild_url: perleImageUrl(item) || null,
          image_version: item.image_version || null
        };
      }),
      spacer: buildSpacerDesignInfo(),
      bedeutungsprofil: buildBedeutungsprofil()
    });
  }

  async function restoreDesign(designId) {
    try {
      const cart = await fetchJson('/cart.js');
      const item = cart.items.find(i =>
        i.properties?._design_id === designId &&
        i.properties?._label !== 'Konfigurator-Aufpreis'
      );
      if (!item || !item.properties?._design_json) return;
      const design = JSON.parse(item.properties._design_json);
      if (design.version !== 2 || !Array.isArray(design.slots)) return;

      const restored = sizeForRestore(design.armband?.groesse, { slotCount: design.armband?.slotCount, slotsLength: design.slots.length });
      if (restored.error) { alert(restored.error); return; }
      if (restored.size) state.groesse = restored.size;

      state.freedSlots = [];
      state.slots = design.slots.map(s => s ? { ...s } : null);

      if (design.spacer && typeof design.spacer === 'object' && design.spacer.mode !== 'none') {
        state.spacerMode = ['manual', 'all'].includes(design.spacer.mode) ? design.spacer.mode : 'none';
        state.selectedSpacerId = design.spacer.id ?? null;
        state.activeSpacerId = design.spacer.id ?? null;
        state.spacerGaps = Array.isArray(design.spacer.gaps)
          ? design.spacer.gaps.filter(g => typeof g === 'number' || CLOSURE_GAP_IDS.includes(g))
          : [];
      } else {
        state.spacerGaps = [];
        state.spacerMode = 'none';
        state.selectedSpacerId = null;
        state.activeSpacerId = null;
      }
      state.spacerConflict = false;
      state.spacerConflictCount = 0;
      state.spacerConflictContext = null;
      state.spacerConflictCandidate = null;
      state.conflictOverlayDismissed = false;
      state.deleteMode = false;

      state.hiddenEmptySlots = 0;

      // Es werden nur leere Plaetze angepasst. Hat ein aelteres Design mehr Natursteine als jetzt Plaetze vorgesehen sind,
      // bleiben alle Steine erhalten und der Kunde wird zum Entfernen aufgefordert (kein stilles Abschneiden).
      adjustSlotsToSize();

      state.closureBead = CLOSURE_BEAD_OPTIONS[design.closure_bead?.finish] ? design.closure_bead.finish : CLOSURE_BEAD_DEFAULT;

      state.history = [];
      renderGroessen();
      renderSlots();
      syncClosureUi();
      updatePriceAndSummary();
      updatePatternButtonLabel();
      renderSpacerStep();
    } catch (e) {
      console.error('DYO: Fehler beim Wiederherstellen des Designs', e);
    }
  }

  function buildPreviewSvgDataUrl() {
    const size = 200, cx = 100, cy = 100, ringR = 70, beadR = 9;
    const count = state.slots.length;
    const previewRotationDeg = count > 0 && count % 2 === 0 ? 180 / count : 0;

    function beadColors(farbe) {
      const f = (farbe || '').toLowerCase();
      if (f.includes('türkis'))  return ['#d9fff1', '#4ca69a'];
      if (f.includes('rot'))     return ['#f0c0bd', '#7b1d22'];
      if (f.includes('grün'))    return ['#e7fff0', '#3d7d54'];
      if (f.includes('blau'))    return ['#d8e4ff', '#3155b8'];
      if (f.includes('gelb'))    return ['#fff6bf', '#e7b438'];
      if (f.includes('orange'))  return ['#ffd69a', '#ec8d35'];
      if (f.includes('rosa'))    return ['#fff2f2', '#e8aeb2'];
      if (f.includes('violett')) return ['#e7d6ff', '#8c58b7'];
      if (f.includes('weiß'))    return ['#ffffff', '#bfc0ba'];
      if (f.includes('schwarz')) return ['#666666', '#242424'];
      if (f.includes('braun'))   return ['#d7a76f', '#8b4d32'];
      return ['#dcebe2', '#6c9278'];
    }

    function spacerSvgColors(farbe) {
      const f = (farbe || '').toLowerCase();
      if (f.includes('weiß') || f.includes('weiss')) return ['#f4efe0', '#c9c2b0'];
      if (f.includes('gold')) return ['#fdeeb0', '#b8862f'];
      if (f.includes('silber')) return ['#f4f4f6', '#9a9ea6'];
      return ['#eeeeee', '#bbbbbb'];
    }

    const gradMap = {};
    state.slots.forEach(perle => {
      if (!perle) return;
      const key = (perle.farbe || '').toLowerCase();
      if (!gradMap[key]) {
        gradMap[key] = { id: `g${Object.keys(gradMap).length}`, colors: beadColors(perle.farbe) };
      }
    });

    const selectedSpacer = getActiveSpacer();
    const showSpacer = state.spacerMode !== 'none' && count > 0 && !!selectedSpacer;
    let spacerDefs = '';
    let spacerShapes = '';

    if (showSpacer) {
      const spacerGradId = 'spacerPreviewGrad';
      const [sc1, sc2] = spacerSvgColors(selectedSpacer.farbe);
      spacerDefs = `<linearGradient id="${spacerGradId}" x1="0%" y1="0%" x2="100%" y2="100%">` +
        `<stop offset="0%" stop-color="${sc1}"/><stop offset="100%" stop-color="${sc2}"/></linearGradient>`;

      const heightRatio = Number(selectedSpacer.aussendurchmesser_mm || 6) / 6;
      const widthRatio = Number(selectedSpacer.dicke_mm || 1.2) / 6;
      const spacerH = Math.max(4, 2 * beadR * heightRatio);
      const spacerW = Math.max(2, 2 * beadR * widthRatio);

      const previewPreceding = getClosurePrecedingStone(count);
      const closureSpacerOffsetDeg = ((beadR * CLOSURE_BEAD_SIZE_MM / BEAD_DIAMETER_MM) + spacerW / 2 + 1) / ringR * (180 / Math.PI);
      const previewSpacerSlots = [];
      for (let i = 0; i < count; i++) {
        if (i === previewPreceding) {
          previewSpacerSlots.push({ filled: state.spacerMode === 'all' || state.spacerGaps.includes(CLOSURE_GAP_RIGHT), angle: 90 - closureSpacerOffsetDeg });
          previewSpacerSlots.push({ filled: state.spacerMode === 'all' || state.spacerGaps.includes(CLOSURE_GAP_LEFT), angle: 90 + closureSpacerOffsetDeg });
        } else {
          previewSpacerSlots.push({
            filled: state.spacerMode === 'all' || state.spacerGaps.includes(i),
            angle: -90 + (360 / count) * (i + 0.5) + previewRotationDeg
          });
        }
      }

      for (const previewSlot of previewSpacerSlots) {
        if (!previewSlot.filled) continue;

        const angle = previewSlot.angle;
        const rad = angle * Math.PI / 180;
        const px = Math.round((cx + ringR * Math.cos(rad)) * 10) / 10;
        const py = Math.round((cy + ringR * Math.sin(rad)) * 10) / 10;
        const rotation = angle + 90;

        spacerShapes += `<rect x="${(px - spacerW / 2).toFixed(1)}" y="${(py - spacerH / 2).toFixed(1)}" ` +
          `width="${spacerW.toFixed(1)}" height="${spacerH.toFixed(1)}" rx="${Math.min(2, spacerW / 2).toFixed(1)}" ` +
          `fill="url(#${spacerGradId})" stroke="rgba(255,255,255,.5)" stroke-width="0.5" ` +
          `transform="rotate(${rotation} ${px} ${py})"/>`;
      }
    }

    let defs = '<defs>';
    Object.values(gradMap).forEach(({ id, colors }) => {
      defs += `<radialGradient id="${id}" cx="35%" cy="30%" r="65%">`;
      defs += `<stop offset="0%" stop-color="${colors[0]}"/>`;
      defs += `<stop offset="100%" stop-color="${colors[1]}"/>`;
      defs += '</radialGradient>';
    });
    defs += spacerDefs;
    defs += '</defs>';

    const fallbackFill = Object.values(gradMap)[0] ? `url(#${Object.values(gradMap)[0].id})` : '#b7d7c3';
    let circles = `<circle cx="${cx}" cy="${cy}" r="${ringR + beadR + 2}" fill="#f0f0f0"/>`;
    circles += `<circle cx="${cx}" cy="${cy}" r="${ringR - beadR - 2}" fill="#ffffff"/>`;
    for (let i = 0; i < count; i++) {
      const rad = (-90 + (360 / count) * i + previewRotationDeg) * Math.PI / 180;
      const x = Math.round((cx + ringR * Math.cos(rad)) * 10) / 10;
      const y = Math.round((cy + ringR * Math.sin(rad)) * 10) / 10;
      const perle = state.slots[i];
      if (perle) {
        const key = (perle.farbe || '').toLowerCase();
        const gId = (gradMap[key] || Object.values(gradMap)[0] || { id: null }).id;
        const fill = gId ? `url(#${gId})` : fallbackFill;
        circles += `<circle cx="${x}" cy="${y}" r="${beadR}" fill="${fill}"/>`;
      } else {
        circles += `<circle cx="${x}" cy="${y}" r="${beadR}" fill="#e0e0e0"/>`;
      }
    }

    circles += spacerShapes;

    const closureColors = state.closureBead === 'gold' ? ['#fff6c6', '#8a5c10'] : ['#ffffff', '#6b7178'];
    defs = defs.replace('</defs>',
      `<radialGradient id="closureGrad" cx="35%" cy="30%" r="65%">` +
      `<stop offset="0%" stop-color="${closureColors[0]}"/><stop offset="100%" stop-color="${closureColors[1]}"/>` +
      `</radialGradient></defs>`);
    circles += `<circle cx="${cx}" cy="${cy + ringR}" r="${(beadR * CLOSURE_BEAD_SIZE_MM / BEAD_DIAMETER_MM).toFixed(1)}" fill="url(#closureGrad)"/>`;

    const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}">${defs}${circles}</svg>`;
    return 'data:image/svg+xml;base64,' + btoa(unescape(encodeURIComponent(svg)));
  }

  function buildSpacerSummaryText() {
    const selected = getActiveSpacer();
    const count = getSpacerCount();

    if (state.spacerMode === 'none' || !selected || count === 0) {
      return 'Keine';
    }

    const sizeLabel = selected.aussendurchmesser_mm
      ? `${Number(selected.aussendurchmesser_mm)} mm`
      : '';
    const farbe = selected.farbe || selected.name;
    return `${count}× ${farbe}${sizeLabel ? ' · ' + sizeLabel : ''}`;
  }

  function fillPatternSlots() {
    const selected = getSelectedSlotContent();
    if (!selected) return;
    const count = state.slots.length;

    // "Jeden 2. Platz": bei ungerader Platzzahl bleibt der letzte Platz leer, damit er nicht direkt neben dem ersten liegt.
    const step = 2;
    const visibleForFill = new Set(getVisibleStoneIndexes(state.slots.length));
    const limit = visibleForFill.size % 2 === 1 ? count - 1 : count;
    for (let i = 0; i < limit; i += step) {
      if (!state.slots[i] && visibleForFill.has(i)) state.slots[i] = selected;
    }
  }

  function updatePatternButtonLabel() {
    const btn = root.querySelector('[data-fill-pattern]');
    if (!btn) return;
    const label = btn.querySelector('.dyo-btn-outline__label');
    if (label) label.textContent = 'Jeden 2. Platz füllen';
  }

  function setStoneTypeTab(nextTab) {
    state.stoneTypeTab = nextTab;
    const nextId = nextTab === 'premiumBead'
      ? (state.selectedPremiumKugelId ?? state.premiumKugeln[0]?.id ?? null)
      : (state.selectedPerleId ?? state.perlen[0]?.id ?? null);
    setActiveSelection(nextTab, nextId);
    root.querySelectorAll('[data-stone-type-tab]').forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.stoneTypeTab === nextTab);
    });
    const naturalStonePanel = root.querySelector('[data-natural-stone-panel]');
    const premiumKugelPanel = root.querySelector('[data-premium-kugel-panel]');
    if (naturalStonePanel) naturalStonePanel.hidden = nextTab !== 'naturalStone';
    if (premiumKugelPanel) premiumKugelPanel.hidden = nextTab !== 'premiumBead';
  }

  function switchSelectionTab(tab) {
    setClosureMenuOpen(false);
    state.mobileSelectionTab = tab;
    root.querySelectorAll('[data-selection-tab]').forEach(btn => {
      btn.classList.toggle('is-active', btn.dataset.selectionTab === tab);
    });
    const natursteinePanel = root.querySelector('[data-selection-panel="natursteine"]');
    const designerPanel = root.querySelector('[data-selection-panel="designer"]');
    const showNatursteinePanel = tab === 'natursteine' || tab === 'premium';
    if (natursteinePanel) natursteinePanel.classList.toggle('is-tab-active', showNatursteinePanel);
    if (designerPanel) designerPanel.classList.toggle('is-tab-active', tab === 'designer');
    if (showNatursteinePanel) {
      setStoneTypeTab(tab === 'premium' ? 'premiumBead' : 'naturalStone');
    }
  }

  const closureImagesPreloaded = new Set();

  function getClosureImageUrl(finish) {
    const resolve = CLOSURE_BEAD_IMAGE_SOURCES[finish];
    return resolve ? resolve() : '';
  }

  function preloadClosureImages() {
    Object.keys(CLOSURE_BEAD_OPTIONS).forEach(finish => {
      const url = getClosureImageUrl(finish);
      if (!url || closureImagesPreloaded.has(url)) return;
      closureImagesPreloaded.add(url);
      new Image().src = url;
    });
  }

  function updateClosureChipState(chip) {
    const img = chip.querySelector(`img[data-closure-img="${chip.dataset.closureChip}"]`);
    chip.dataset.imageLoaded = img && img.dataset.state === 'ok' ? 'true' : 'false';
  }

  function ensureClosureChipImages(chip) {
    Object.keys(CLOSURE_BEAD_OPTIONS).forEach(finish => {
      const url = getClosureImageUrl(finish);
      let img = chip.querySelector(`img[data-closure-img="${finish}"]`);
      if (!url) {
        if (img) img.remove();
        return;
      }
      if (img && img.getAttribute('src') === url && img.dataset.state !== 'error') return;
      if (img) img.remove();
      img = document.createElement('img');
      img.className = 'dyo-closure-chip__image';
      img.alt = '';
      img.decoding = 'async';
      img.draggable = false;
      img.dataset.closureImg = finish;
      const settle = ok => {
        img.dataset.state = ok ? 'ok' : 'error';
        updateClosureChipState(chip);
      };
      img.addEventListener('load', () => settle(true));
      img.addEventListener('error', () => settle(false));
      img.src = url;
      chip.appendChild(img);
      if (img.complete && img.getAttribute('src')) settle(img.naturalWidth > 0);
    });
    updateClosureChipState(chip);
  }

  function syncClosureChips() {
    preloadClosureImages();
    root.querySelectorAll('[data-closure-chip]').forEach(ensureClosureChipImages);
  }

  function bindClosureImageFallback(image) {
    const dropImage = () => {
      const bead = image.closest('[data-ring-closure]');
      image.remove();
      if (bead) bead.dataset.image = 'false';
    };
    image.addEventListener('error', dropImage);
    if (image.complete && image.naturalWidth === 0 && image.getAttribute('src')) dropImage();
  }

  function syncClosureUi() {
    const finish = CLOSURE_BEAD_OPTIONS[state.closureBead] ? state.closureBead : CLOSURE_BEAD_DEFAULT;
    const closureImageUrl = getClosureImageUrl(finish);
    slotRoot.querySelectorAll('[data-ring-closure]').forEach(bead => {
      bead.dataset.finish = finish;
      const current = bead.querySelector('.dyo-ring-closure__image');
      if (!closureImageUrl) {
        if (current) current.remove();
        bead.dataset.image = 'false';
        return;
      }
      if (current && current.getAttribute('src') === closureImageUrl) return;
      if (current) current.remove();
      bead.dataset.image = 'true';
      const image = document.createElement('img');
      image.className = 'dyo-ring-closure__image';
      image.alt = '';
      image.loading = 'eager';
      image.decoding = 'async';
      image.src = closureImageUrl;
      bindClosureImageFallback(image);
      bead.appendChild(image);
    });
    root.querySelectorAll('[data-closure-option]').forEach(btn => {
      const active = btn.dataset.closureOption === finish;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', String(active));
    });
    const triggerChip = root.querySelector('[data-closure-trigger-chip]');
    if (triggerChip) {
      triggerChip.className = `dyo-closure-chip dyo-closure-finish--${finish}`;
      triggerChip.dataset.closureChip = finish;
    }
    syncClosureChips();
  }

  function setClosureMenuOpen(open) {
    const trigger = root.querySelector('[data-closure-trigger]');
    const menu = root.querySelector('[data-closure-menu]');
    if (!trigger || !menu) return;
    menu.hidden = !open;
    trigger.setAttribute('aria-expanded', String(open));
  }

  function setClosureBead(finish) {
    if (!CLOSURE_BEAD_OPTIONS[finish]) return;
    if (state.closureBead !== finish) {
      pushHistory();
      state.closureBead = finish;
      syncClosureUi();
      undoBtn.disabled = state.history.length === 0;
    }
    setClosureMenuOpen(false);
  }

  function setHowtoStepOpen(stepEl, open) {
    const toggleBtn = stepEl.querySelector('[data-howto-toggle]');
    const panel = stepEl.querySelector('.dyo-howto-step__panel');
    if (!toggleBtn || !panel) return;

    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (open) {
      panel.hidden = false;
      toggleBtn.setAttribute('aria-expanded', 'true');
      stepEl.classList.add('is-open');
      if (reduceMotion) return;
      panel.style.gridTemplateRows = '0fr';
      void panel.offsetHeight;
      requestAnimationFrame(() => {
        panel.style.gridTemplateRows = '1fr';
      });
    } else {
      toggleBtn.setAttribute('aria-expanded', 'false');
      stepEl.classList.remove('is-open');
      if (reduceMotion) {
        panel.hidden = true;
        return;
      }
      panel.style.gridTemplateRows = '0fr';
      const onEnd = (evt) => {
        if (evt.target !== panel || evt.propertyName !== 'grid-template-rows') return;
        panel.hidden = true;
        panel.removeEventListener('transitionend', onEnd);
      };
      panel.addEventListener('transitionend', onEnd);
    }
  }

  function toggleHowtoStep(stepEl) {
    const toggleBtn = stepEl.querySelector('[data-howto-toggle]');
    if (!toggleBtn) return;
    const willOpen = toggleBtn.getAttribute('aria-expanded') !== 'true';

    if (willOpen) {
      root.querySelectorAll('[data-howto-step]').forEach(other => {
        if (other !== stepEl) setHowtoStepOpen(other, false);
      });
    }
    setHowtoStepOpen(stepEl, willOpen);
  }

  function focusSpacerPanel() {
    if (state.spacerConflict) {

      state.conflictOverlayDismissed = false;
      renderConflictOverlay();
      const overlay = root.querySelector('[data-conflict-overlay]');
      if (overlay) {
        overlay.setAttribute('tabindex', '-1');
        overlay.scrollIntoView({ behavior: 'smooth', block: 'center' });
        overlay.focus({ preventScroll: true });
      }
      return;
    }

    switchSelectionTab('designer');
    const target = root.querySelector('[data-spacer-select-hint]');
    if (target) {
      target.setAttribute('tabindex', '-1');
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      target.focus({ preventScroll: true });
    }
  }

  const DESIGN_IMAGE_SIZE = 900;
  // Neue Admin-Varianten koennen wenige Sekunden brauchen, bis Shopifys
  // Storefront-Warenkorb sie kennt. Nur eindeutige 404/422-Antworten werden
  // begrenzt wiederholt; Netzwerk- und andere Serverfehler nicht.
  const CART_VARIANT_RETRY_MS = [450, 850, 1400, 2200, 3200];

  function loadCrossOriginImage(url) {
    return new Promise(resolve => {
      if (!url) return resolve(null);
      const img = new Image();
      img.crossOrigin = 'anonymous';
      const timer = setTimeout(() => resolve(null), 8000);
      img.onload = () => { clearTimeout(timer); resolve(img); };
      img.onerror = () => { clearTimeout(timer); resolve(null); };
      img.src = url;
    });
  }

  function opaqueBounds(img) {
    try {
      const c = document.createElement('canvas');
      c.width = 64;
      c.height = 64;
      const g = c.getContext('2d');
      g.drawImage(img, 0, 0, 64, 64);
      const data = g.getImageData(0, 0, 64, 64).data;
      let x0 = 64, x1 = -1, y0 = 64, y1 = -1;
      for (let y = 0; y < 64; y++) {
        for (let x = 0; x < 64; x++) {
          if (data[(y * 64 + x) * 4 + 3] > 16) {
            if (x < x0) x0 = x;
            if (x > x1) x1 = x;
            if (y < y0) y0 = y;
            if (y > y1) y1 = y;
          }
        }
      }
      if (x1 < 0) return null;
      const sx = img.naturalWidth / 64, sy = img.naturalHeight / 64;
      return { x: x0 * sx, y: y0 * sy, w: (x1 - x0 + 1) * sx, h: (y1 - y0 + 1) * sy };
    } catch (err) {
      return null;
    }
  }

  function exportFallbackColors(kind, farbe) {
    const f = String(farbe || '').toLowerCase();
    if (kind === 'closure') return farbe === 'gold' ? ['#fff6c6', '#8a5c10'] : ['#ffffff', '#6b7178'];
    if (f.includes('gold')) return ['#fdeeb0', '#b8862f'];
    if (f.includes('silber')) return ['#f4f4f6', '#8a8e96'];
    if (f.includes('türkis')) return ['#d9fff1', '#4ca69a'];
    if (f.includes('rot')) return ['#f0c0bd', '#7b1d22'];
    if (f.includes('grün')) return ['#e7fff0', '#3d7d54'];
    if (f.includes('blau')) return ['#d8e4ff', '#3155b8'];
    if (f.includes('gelb')) return ['#fff6bf', '#e7b438'];
    if (f.includes('violett')) return ['#e7d6ff', '#8c58b7'];
    if (f.includes('schwarz')) return ['#666666', '#242424'];
    if (f.includes('weiß') || f.includes('weiss')) return ['#ffffff', '#bfc0ba'];
    if (f.includes('braun')) return ['#d7a76f', '#8b4d32'];
    return ['#dcebe2', '#6c9278'];
  }

  function drawExportSphere(ctx, img, cx, cy, d, colors) {
    ctx.save();
    ctx.beginPath();
    ctx.arc(cx, cy, d / 2, 0, Math.PI * 2);
    ctx.clip();
    if (img) {
      const b = opaqueBounds(img) || { x: 0, y: 0, w: img.naturalWidth, h: img.naturalHeight };
      const side = Math.max(b.w, b.h);
      ctx.drawImage(img, b.x + b.w / 2 - side / 2, b.y + b.h / 2 - side / 2, side, side, cx - d / 2, cy - d / 2, d, d);
    } else {
      const grad = ctx.createRadialGradient(cx - d * 0.15, cy - d * 0.2, d * 0.05, cx, cy, d / 2);
      grad.addColorStop(0, colors[0]);
      grad.addColorStop(1, colors[1]);
      ctx.fillStyle = grad;
      ctx.fillRect(cx - d / 2, cy - d / 2, d, d);
    }
    ctx.restore();
    ctx.strokeStyle = 'rgba(0,0,0,.18)';
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.arc(cx, cy, d / 2, 0, Math.PI * 2);
    ctx.stroke();
  }

  function drawExportSpacer(ctx, img, x, y, w, h, angleDeg, colors) {
    ctx.save();
    ctx.translate(x, y);
    ctx.rotate((angleDeg + 90) * Math.PI / 180);
    const radius = Math.min(w, h) * 0.35;
    const grad = ctx.createLinearGradient(-w / 2, 0, w / 2, 0);
    grad.addColorStop(0, colors[0]);
    grad.addColorStop(0.55, colors[1]);
    grad.addColorStop(1, colors[0]);
    ctx.beginPath();
    ctx.roundRect(-w / 2, -h / 2, w, h, radius);
    ctx.fillStyle = grad;
    ctx.fill();
    if (img) {
      const b = opaqueBounds(img) || { x: 0, y: 0, w: img.naturalWidth, h: img.naturalHeight };
      const k = Math.min(w / b.w, h / b.h);
      ctx.drawImage(img, b.x, b.y, b.w, b.h, -b.w * k / 2, -b.h * k / 2, b.w * k, b.h * k);
    }
    ctx.beginPath();
    ctx.roundRect(-w / 2, -h / 2, w, h, radius);
    ctx.strokeStyle = 'rgba(35,25,12,.72)';
    ctx.lineWidth = Math.max(1.5, Math.min(w, h) * 0.09);
    ctx.stroke();
    ctx.restore();
  }

  async function exportDesignImage() {
    const cfg = buildEngineConfig();
    const order = DyoEngine.readingOrder(cfg);
    const size = DESIGN_IMAGE_SIZE;
    const R = size * 0.33;
    // In der kleinen Warenkorbansicht waeren reale Spacer-Dicken von etwa
    // 1 mm kaum erkennbar. Nur fuer das Vorschaubild werden sie deshalb
    // moderat verbreitert; Anzahl, Reihenfolge und Berechnung bleiben gleich.
    const previewOrder = order.map(e => {
      if (e.kind === 'rondell') return { ...e, widthMm: Math.max(4, Number(e.widthMm) || 0) };
      if (e.kind === 'spacer') return { ...e, widthMm: Math.max(3.2, Number(e.widthMm) || 0) };
      return e;
    });
    const lay = DyoEngine.layoutRing(previewOrder, R);
    const totalMm = lay.reduce((sum, e) => sum + e.visualWidthMm, 0);
    const unit = (2 * Math.PI * R) / totalMm;
    const urls = lay.map(e => {
      if (e.kind === 'closure') return getClosureImageUrl(e.finish);
      if (e.kind === 'stone') return perleImageUrl(e.item);
      if (e.kind === 'designBead') return premiumKugelImageUrl(e.item);
      return spacerRingImageUrl(e.spacer);
    });
    const loaded = new Map();
    await Promise.all([...new Set(urls.filter(Boolean))].map(async url => loaded.set(url, await loadCrossOriginImage(url))));

    const fallbacks = [];
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, size, size);
    ctx.strokeStyle = '#d9d4ca';
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.arc(size / 2, size / 2, R, 0, Math.PI * 2);
    ctx.stroke();

    const drawOrder = [...lay.keys()].sort((a, b) => {
      const sp = i => (lay[i].kind === 'spacer' || lay[i].kind === 'rondell' ? 1 : 0);
      return sp(a) - sp(b);
    });
    drawOrder.forEach(i => {
      const e = lay[i];
      const img = urls[i] ? loaded.get(urls[i]) : null;
      if (!img) fallbacks.push(e.name);
      const x = size / 2 + e.x, y = size / 2 + e.y;
      if (e.kind === 'spacer' || e.kind === 'rondell') {
        drawExportSpacer(ctx, img, x, y, e.visualWidthMm * unit, Math.max(4, (e.diameterMm || 5) * unit), e.angle, exportFallbackColors('spacer', e.farbe));
      } else {
        const d = (e.kind === 'closure' ? DyoEngine.CLOSURE_MM : DyoEngine.BEAD_MM) * unit;
        drawExportSphere(ctx, img, x, y, d, exportFallbackColors(e.kind === 'closure' ? 'closure' : 'stone', e.kind === 'closure' ? e.finish : e.farbe));
      }
    });

    let dataUrl = null;
    try {
      dataUrl = canvas.toDataURL('image/jpeg', 0.88);
    } catch (err) {
      fallbacks.push('Bildexport');
    }
    return { dataUrl, fallbacks: [...new Set(fallbacks)] };
  }

  function buildServerPayload(image) {
    const spacer = getActiveSpacer();
    return {
      size: state.groesse ? state.groesse.key : null,
      closure: state.closureBead,
      spacerMode: state.spacerMode,
      spacerId: spacer && state.spacerMode !== 'none' ? spacer.id : null,
      gaps: state.spacerMode === 'manual' ? state.spacerGaps : [],
      slots: state.slots.map(slot => (slot ? { t: slot.contentType === 'premiumBead' ? 'd' : 's', id: slot.id } : null)),
      clientPriceCents: DyoEngine.cents(state.totalPreis),
      image: image && image.dataUrl ? { dataUrl: image.dataUrl, fallbacks: image.fallbacks } : undefined
    };
  }

  function userError(message) {
    const err = new Error(message);
    err.userMessage = message;
    return err;
  }

  // ---------------------------------------------------------------------------
  // Warenkorb-Ablauf in drei getrennten Phasen:
  //   1. Design anlegen (POST /api/designs)        -> Fehler: nichts liegt im Warenkorb
  //   2. In den Warenkorb legen (POST /cart/add.js) -> Fehler nur, wenn der Artikel NICHT im Warenkorb liegt
  //   3. Warenkorb darstellen (Drawer)              -> Darstellungsfehler sind KEIN Hinzufuegen-Fehler
  // Schreibende Warenkorb-Anfragen werden nur nach EINDEUTIGER Ablehnung (4xx mit Antwort) wiederholt. Bei unklarem
  // Ausgang (Netzfehler, Zeitueberschreitung, 5xx) gibt es KEINEN automatischen zweiten Hinzufuegen-Request:
  // ein leerer Warenkorb beweist nicht, dass die erste Anfrage nicht noch verarbeitet wird.
  // ---------------------------------------------------------------------------
  const DESIGN_REQUEST_TIMEOUT_MS = 45000;
  const CART_REQUEST_TIMEOUT_MS = 20000;
  const CART_READ_TIMEOUT_MS = 8000;
  // Nach unklarem Ausgang wird NIE erneut hinzugefuegt. Der Warenkorb wird nur gelesen, um eine verspaetete
  // Verarbeitung der ersten Anfrage zu erkennen (Button bleibt waehrenddessen gesperrt).
  const CART_LATE_WATCH_MS = 20000;
  const CART_LATE_POLL_MS = 2500;
  // Eine von UNS gerade neu angelegte Variante ist im Storefront-Warenkorb erst nach einigen Sekunden kaufbar. Nur in diesem Zeitfenster
  // nach dem Anlegen (Antwort "reused: false" auf dieser Seite) wird eine eindeutige 404/422-Antwort begrenzt wiederholt.
  const CART_FRESH_VARIANT_WINDOW_MS = 30000;
  const freshVariants = new Map(); // Varianten-ID -> Zeitpunkt, zu dem diese Seite sie als NEU angelegt gesehen hat
  // Eindeutige Mengen-/Limitfehler (englisch und deutsch) werden nie wiederholt. Bestandsfehler ("ausverkauft") werden ausserhalb des
  // Frische-Fensters ebenfalls nie wiederholt; innerhalb davon nicht, weil unsere Varianten ohne Bestandsfuehrung angelegt werden.
  const CART_QUANTITY_LIMIT_PATTERN = /can'?t add more|cannot add more|more than (the )?(available|stock)|nicht mehr .*(hinzu|warenkorb|legen)|keine weiteren .*(hinzu|warenkorb)|maximal|maximum/i;

  function fetchWithTimeout(url, options, timeoutMs) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), timeoutMs);
    return fetch(url, { ...options, signal: controller.signal }).finally(() => clearTimeout(timer));
  }

  function diagText(value) {
    return String(value === undefined || value === null ? '' : value).replace(/[^\wäöüÄÖÜß .,:;=()\/-]/g, '').slice(0, 40);
  }

  // Laengere, bereinigte Texte fuer die Diagnose (Fehlermeldungen, Content-Type): nur Buchstaben, Ziffern und einfache Satzzeichen.
  function diagLong(value, max) {
    return String(value === undefined || value === null ? '' : value)
      .replace(/[^\wäöüÄÖÜß .,:;=()\/'„“”‚‘’-]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, max);
  }

  function cartAddError(kind, status, detail) {
    const err = new Error(`Cart-Fehler (${kind}${status ? ' ' + status : ''})`);
    err.cartKind = kind; // 'rejected' = nachweislich nicht hinzugefuegt, 'unclear' = Ausgang unklar
    err.cartStatus = status || 0;
    err.cartDetail = detail || '';
    return err;
  }

  async function createServerDesign() {
    // Konfiguration und Bild werden im selben synchronen Schritt festgehalten, damit sie auch bei
    // Aenderungen waehrend des Bildexports/Uploads zusammenpassen.
    const payload = buildServerPayload(null);
    const imagePromise = exportDesignImage();
    const image = await imagePromise;
    if (image && image.dataUrl) payload.image = { dataUrl: image.dataUrl, fallbacks: image.fallbacks };
    const startedAt = Date.now();
    let res;
    try {
      res = await fetchWithTimeout(`${API_BASE}/designs`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }, DESIGN_REQUEST_TIMEOUT_MS);
    } catch (networkError) {
      logDiag('design_net', `${networkError && networkError.name === 'AbortError' ? 'timeout' : 'net'} ${Date.now() - startedAt}ms`);
      sendDiagnostic(networkError && networkError.name === 'AbortError' ? 'design_create_timeout' : 'design_create_network');
      throw userError('Die Verbindung zum Server ist fehlgeschlagen. Es wurde nichts in den Warenkorb gelegt. Bitte versuche es erneut.');
    }
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      logDiag('design_http', `${res.status} ${diagText(json.error)} ${Date.now() - startedAt}ms`);
      sendDiagnostic(`design_create_${res.status}`);
    }
    if (res.status === 503) {
      throw userError('Die Bestellfunktion ist gerade nicht verfügbar. Dein Design wurde nicht in den Warenkorb gelegt und bleibt hier erhalten. Bitte versuche es später erneut oder schreibe uns kurz – wir helfen dir gern.');
    }
    if (res.status === 429) {
      throw userError(json.message || 'Es wurden sehr viele Designs in kurzer Zeit angelegt. Bitte warte kurz und versuche es dann erneut.');
    }
    if (res.status === 409 && json.error === 'PRICE_CHANGED') {
      throw userError(`Der Preis hat sich geändert (jetzt ${money(json.priceCents / 100)}). Bitte lade die Seite neu und prüfe dein Design.`);
    }
    if (!res.ok) throw userError(json.message || 'Das Design konnte nicht gespeichert werden. Es wurde nichts in den Warenkorb gelegt.');
    if (json.reused === false && json.variantId) freshVariants.set(Number(json.variantId), Date.now());
    return { variantId: json.variantId, properties: json.properties, reused: json.reused === true, designMs: Date.now() - startedAt };
  }

  function designIdOf(properties) {
    return (properties && (properties['_dyo_design_id'] || properties['Design-ID'])) || '';
  }

  // Menge dieser Design-Position im Warenkorb; null, wenn der Warenkorb nicht lesbar ist.
  async function readDesignLineQuantity(variantId, designId) {
    try {
      const res = await fetchWithTimeout('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }, CART_READ_TIMEOUT_MS);
      if (!res.ok) return null;
      const cart = await res.json();
      return (cart.items || [])
        .filter(item => Number(item.id) === variantId && designIdOf(item.properties) === designId)
        .reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    } catch (readError) {
      return null;
    }
  }

  // Antwortdaten einer Ablehnung. Der Antworttext wird IMMER als Text gelesen (unabhaengig vom Content-Type: Shopify liefert die
  // Cart-Fehler zum Beispiel nicht als application/json); JSON wird zusaetzlich sicher zu parsen versucht.
  //   contentType: vollstaendiger Content-Type (bereinigt), text: bereinigte Meldung (bis 120 Zeichen),
  //   haystack: Rohtext fuer die Einordnung, meta: Content-Type + cf (cf-ray vorhanden) + raN (Retry-After).
  // Der Ursprung einer Ablehnung wird nicht vorab behauptet, sondern aus diesen Daten eingeordnet.
  async function readErrorInfo(res) {
    const contentType = diagLong(res.headers.get('content-type') || '', 60) || 'leer';
    const retryAfter = res.headers.get('retry-after');
    let raw = '';
    try { raw = await res.clone().text(); } catch (readError) { raw = ''; }
    let message = '';
    let description = '';
    try {
      const json = JSON.parse(raw);
      if (json && typeof json === 'object') {
        message = String(json.message || '');
        description = String(json.description || '');
      }
    } catch (parseError) { /* kein JSON: Rohtext wird trotzdem ausgewertet */ }
    const body = description || message || raw.replace(/<[^>]*>/g, ' ');
    return {
      contentType,
      text: diagLong(body, 120),
      haystack: `${description} ${message} ${raw.slice(0, 600)}`,
      meta: [contentType, res.headers.get('cf-ray') ? 'cf' : '', retryAfter ? 'ra' + diagLong(retryAfter, 6) : ''].filter(Boolean).join(' ')
    };
  }

  // Einordnung einer EINDEUTIGEN Ablehnung (Antwort wurde empfangen, es wurde nichts hinzugefuegt):
  //  - rate_limited: 429 -> nie automatisch wiederholen (Ursprung offen, siehe meta in der Diagnose).
  //  - quantity_limit: 404/422 mit eindeutigem Mengen-/Limittext (englisch/deutsch) -> nie wiederholen.
  //  - variant_not_ready: 404/422 UNMITTELBAR nach einer von uns neu angelegten Variante (fresh) -> begrenzt wiederholen. Das haengt
  //    bewusst NICHT vom (sprachabhaengigen) Fehlertext ab.
  //  - permanent: alles andere (nicht frische Variante, andere Statuscodes) -> nie wiederholen.
  // Quellen: shopify.dev Ajax Cart API (nur 422 "Cart Error" fuer Bestand/Menge dokumentiert); Shopify-Community (frisch angelegte
  // Variante liefert 422, Dauer ca. 1-6+ s); Produktionslog vom 15.10.: 422 mit deutschem Text, Content-Type nicht JSON.
  function classifyCartRejection(status, info, fresh) {
    if (status === 429) return 'rate_limited';
    if (status === 404 || status === 422) {
      if (CART_QUANTITY_LIMIT_PATTERN.test(info.haystack)) return 'quantity_limit';
      if (fresh) return 'variant_not_ready';
    }
    return 'permanent';
  }

  // Wartet lesend darauf, dass eine zeitueberschrittene/unklare Anfrage doch noch verarbeitet wurde.
  async function waitForLateAdd(variantId, designId, baseline) {
    if (baseline === null) return false;
    const deadline = Date.now() + CART_LATE_WATCH_MS;
    while (Date.now() < deadline) {
      await new Promise(resolve => setTimeout(resolve, CART_LATE_POLL_MS));
      const quantity = await readDesignLineQuantity(variantId, designId);
      if (quantity !== null && quantity > baseline) return true;
    }
    return false;
  }

  async function addDesignToCart(design) {
    const variantId = Number(design.variantId);
    const designId = designIdOf(design.properties);
    const baseline = await readDesignLineQuantity(variantId, designId);
    const body = JSON.stringify({
      items: [{ id: variantId, quantity: 1, properties: design.properties }],
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname
    });

    const createdAt = freshVariants.get(variantId);
    const isFresh = () => createdAt !== undefined && Date.now() - createdAt <= CART_FRESH_VARIANT_WINDOW_MS;
    let waitedRetries = 0;
    for (let attempt = 0; ; attempt++) {
      const startedAt = Date.now();
      let res = null;
      let networkProblem = false;
      try {
        res = await fetchWithTimeout('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body }, CART_REQUEST_TIMEOUT_MS);
      } catch (networkError) {
        networkProblem = true;
        logDiag('cart_net', `${networkError && networkError.name === 'AbortError' ? 'timeout' : 'net'} ${Date.now() - startedAt}ms`);
      }

      if (res && res.ok) {
        let data = null;
        try { data = await res.json(); } catch (parseError) { data = null; }
        if (waitedRetries > 0) { logDiag('cart_ok_after_retry', `retries=${waitedRetries}`); sendDiagnostic(`cart_variant_delay_${waitedRetries}`); }
        return { data, designMs: design.designMs, cartMs: Date.now() - startedAt, retries: waitedRetries };
      }

      if (res && !networkProblem && res.status < 500 && res.status !== 408) {
        // Eindeutige Ablehnung: es wurde nichts hinzugefuegt.
        const info = await readErrorInfo(res);
        const reason = classifyCartRejection(res.status, info, isFresh());
        logDiag('cart_http', `${res.status} ${info.meta} ${info.text}`.trim());
        if (reason === 'variant_not_ready' && attempt < CART_VARIANT_RETRY_MS.length) {
          addBtn.textContent = 'Design wird vorbereitet …';
          waitedRetries++;
          await new Promise(resolve => setTimeout(resolve, CART_VARIANT_RETRY_MS[attempt]));
          continue;
        }
        sendDiagnostic(reason === 'variant_not_ready' ? `cart_add_variant_not_ready_${res.status}` : reason === 'rate_limited' ? 'cart_add_rate_limited' : reason === 'quantity_limit' ? `cart_add_quantity_limit_${res.status}` : `cart_add_rejected_${res.status}`);
        const rejected = cartAddError('rejected', res.status, info.text);
        rejected.cartReason = reason;
        throw rejected;
      }

      // Netzwerkfehler, Zeitueberschreitung oder 5xx: Ausgang UNKLAR. Die Anfrage kann noch verarbeitet werden
      // (auch wenn die Antwort verloren ging oder wir abgebrochen haben). Deshalb: nur lesen, nie erneut senden.
      if (res) logDiag('cart_http', `${res.status} unclear`);
      const statusForLog = res ? res.status : 0;
      const quantity = await readDesignLineQuantity(variantId, designId);
      if (quantity !== null && baseline !== null && quantity > baseline) {
        logDiag('cart_verified', `q=${baseline}>${quantity}`);
        sendDiagnostic('cart_add_unclear_but_added');
        return { data: null, designMs: design.designMs, cartMs: Date.now() - startedAt, retries: waitedRetries };
      }
      addBtn.textContent = 'Warenkorb wird geprüft …';
      if (await waitForLateAdd(variantId, designId, baseline)) {
        logDiag('cart_late_arrival', `status=${statusForLog}`);
        sendDiagnostic('cart_add_late_arrival');
        return { data: null, designMs: design.designMs, cartMs: Date.now() - startedAt, retries: waitedRetries };
      }
      sendDiagnostic(`cart_add_unclear_${statusForLog}`);
      throw cartAddError('unclear', statusForLog, '');
    }
  }

  async function fetchCartSections() {
    const res = await fetchWithTimeout(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`, { headers: { Accept: 'application/json' }, cache: 'no-store' }, CART_READ_TIMEOUT_MS);
    if (!res.ok) throw new Error('sections ' + res.status);
    return res.json();
  }

  // Phase 3: Darstellung. Schlaegt sie fehl, liegt der Artikel trotzdem im Warenkorb -> nie "Fehler" melden.
  async function showCartAfterAdd(addResult, variantId) {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') {
      window.location.href = '/cart';
      return;
    }
    const render = payload => {
      if (cartDrawer.classList.contains('is-empty')) cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(payload);
      if (typeof dyoRenderPreviews === 'function') dyoRenderPreviews();
    };
    const complete = addResult.data && addResult.data.sections && addResult.data.sections['cart-drawer'];
    try {
      if (complete) render(addResult.data);
      else render({ id: variantId, sections: await fetchCartSections() });
    } catch (renderError) {
      logDiag('cart_render_fail', diagText(renderError && renderError.message));
      sendDiagnostic('cart_render_failed_after_add');
      try {
        render({ id: variantId, sections: await fetchCartSections() });
      } catch (secondError) {
        window.location.href = '/cart';
      }
    }
  }

  async function addToCart() {
    if (cartRequestBusy) return;
    if (state.spacerNotice) { state.spacerNotice = null; renderConflictOverlay(); } // der Warenkorb-Klick aendert nie die Anordnung; eine alte Ablehnungsmeldung entfaellt

    const orderability = getOrderability();
    if (!orderability.orderable) {
      logDiag('cart_blocked', orderability.reasons.map(r => r.code).join(','));
      sendDiagnostic(`cart_blocked_${orderability.reasons[0].code}`);
      renderCartReason(orderability);
      if (orderability.reasons.some(r => r.code === 'SPACER_MISSING' || r.code === 'GAP_INVALID' || r.code === 'GAP_DUPLICATE')) focusSpacerPanel();
      return;
    }

    cartRequestBusy = true;
    addBtn.disabled = true;
    addBtn.textContent = 'Wird hinzugefügt …';
    if (mobileCartHandle) mobileCartHandle.disabled = true;

    const finish = (label, delayMs) => {
      addBtn.textContent = label;
      setTimeout(() => {
        addBtn.textContent = 'Design in den Warenkorb';
        cartRequestBusy = false;
        updatePriceAndSummary();
      }, delayMs);
    };

    let phase = 'design';
    try {
      const design = await createServerDesign();
      phase = 'cart';
      const addResult = await addDesignToCart(design);
      phase = 'render';
      await showCartAfterAdd(addResult, Number(design.variantId));
      addBtn.textContent = 'Design in den Warenkorb';
      cartRequestBusy = false;
      updatePriceAndSummary();
      return true;
    } catch (err) {
      console.error(err);
      if (phase === 'render') {
        // Der Artikel liegt bereits im Warenkorb; keine Fehlermeldung, die zum erneuten Hinzufuegen verleitet.
        addBtn.textContent = 'Design in den Warenkorb';
        cartRequestBusy = false;
        updatePriceAndSummary();
        return true;
      }
      if (err.cartKind === 'unclear') {
        alert('Wir konnten nicht bestätigen, ob dein Design im Warenkorb liegt. Es kann sein, dass es gleich noch erscheint. Bitte öffne den Warenkorb und prüfe ihn, bevor du es erneut hinzufügst.');
        try { await showCartAfterAdd({ data: null }, 0); } catch (e) { /* Warenkorbsymbol bleibt erreichbar */ }
        finish('Bitte Warenkorb prüfen', 4000);
        return false;
      }
      if (err.cartReason === 'rate_limited') alert('Der Shop hat die Anfrage vorübergehend abgelehnt (Fehler 429). Dein Design wurde nicht in den Warenkorb gelegt. Bitte warte etwa eine Minute und versuche es dann erneut.');
      if (err.userMessage) alert(err.userMessage);
      finish(err.message && err.message.startsWith('Konfigurationsfehler') ? err.message : 'Fehler – bitte erneut versuchen', 3000);
      return false;
    }
  }

  // Groesse beim Wiederherstellen eines gespeicherten Designs: gleiche Platzanzahl wie damals. Gibt es dafuer keine waehlbare Groesse mehr
  // (frueher 24/26/28 Plaetze oder das fruehere L mit 29 Plaetzen = Schluessel G29), wird der ausgelaufene Schluessel nur fuer dieses Design verwendet
  // (kein Button, damit nichts veraendert wird). Ausgelaufene Schluessel werden nie auf eine aktuelle Groesse umgedeutet (G29 = L ca. 19 cm, nicht das neue M).
  // Stellt die Groesse eines gespeicherten Designs unveraendert wieder her (kein Umschluesseln: frueheres "M" = ca. 17 cm bleibt "M" und wird nie zum
  // heutigen M/G29M). meta = { slotCount, slotsLength }; passt die gespeicherte Belegung nicht zum Schluessel, wird NICHT wiederhergestellt.
  // Ergebnis: { size } (null = keine Groessenangabe vorhanden) oder { error } mit Text fuer den Kunden.
  function sizeForRestore(rawKey, meta) {
    const chk = window.DyoEngine.restoreSizeInfo(rawKey, meta);
    if (!chk.ok) {
      if (chk.reason === 'SIZE_UNKNOWN') return rawKey ? { error: 'Dieses Design verwendet eine unbekannte Armbandgröße und kann nicht wiederhergestellt werden.' } : { size: null };
      return { error: `Dieses ältere Design (Größe ${chk.info.text}) ist nicht eindeutig: gespeichert sind ${chk.stored} Plätze, die Größe kennt ${chk.expected}. Es wurde nichts verändert und nichts abgeschnitten. Die Fertigungsdaten der Bestellung bleiben unberührt; bitte stelle das Armband neu zusammen.` };
    }
    const listed = state.groessen.find(g => g.key === chk.key);
    if (listed) return { size: listed };
    const info = chk.info;
    return { size: { id: info.slots, key: chk.key, groesse: info.label, cm: info.cm, slots: info.slots, retired: true } };
  }

  async function restoreDesignFromServer(designId, token) {
    try {
      const cfg = await fetchJson(`${API_BASE}/designs/${encodeURIComponent(designId)}/config?t=${encodeURIComponent(token)}`);
      const restored = sizeForRestore(cfg.size, { slotCount: cfg.slotCount === null ? undefined : cfg.slotCount, slotsLength: (cfg.slots || []).length });
      if (restored.error) { alert(restored.error); return; }
      if (restored.size) state.groesse = restored.size;

      let missing = 0;
      state.freedSlots = [];
      state.slots = (cfg.slots || []).map(entry => {
        if (!entry) return null;
        const found = entry.t === 'd'
          ? state.premiumKugeln.find(k => Number(k.id) === Number(entry.id))
          : state.perlen.find(p => Number(p.id) === Number(entry.id));
        if (!found) missing++;
        return found || null;
      });

      if (cfg.spacerMode && cfg.spacerMode !== 'none' && cfg.spacerId !== null) {
        state.spacerMode = cfg.spacerMode === 'manual' ? 'manual' : 'all';
        state.selectedSpacerId = cfg.spacerId;
        state.activeSpacerId = cfg.spacerId;
        state.spacerGaps = state.spacerMode === 'manual' && Array.isArray(cfg.gaps) ? [...cfg.gaps] : [];
      } else {
        state.spacerMode = 'none';
        state.selectedSpacerId = null;
        state.activeSpacerId = null;
        state.spacerGaps = [];
      }
      state.spacerConflict = false;
      state.spacerConflictCount = 0;
      state.spacerConflictContext = null;
      state.spacerConflictCandidate = null;
      state.conflictOverlayDismissed = false;
      state.deleteMode = false;
      state.hiddenEmptySlots = 0;
      state.closureBead = CLOSURE_BEAD_OPTIONS[cfg.closure] ? cfg.closure : CLOSURE_BEAD_DEFAULT;
      state.history = [];

      renderGroessen();
      renderSlots();
      syncClosureUi();
      updatePriceAndSummary();
      updatePatternButtonLabel();
      renderSpacerStep();
      if (missing > 0) alert(`${missing} Bauteil(e) dieses Designs sind aktuell nicht mehr verfügbar. Bitte ergänze die leeren Plätze.`);
    } catch (e) {
      console.error('DYO: Design konnte nicht wiederhergestellt werden', e);
    }
  }

  function applyMobileCartOffset(offset, animated) {
    if (!mobileCartHandle || !mobileCartSlider) return;
    const track = mobileCartHandle.closest('[data-mobile-cart-slider]') || mobileCartSlider;
    track.classList.toggle('is-settling', !!animated);
    const trackWidth = track.clientWidth;
    const handleWidth = mobileCartHandle.offsetWidth || MOBILE_CART_HANDLE_SIZE;
    const maxTravel = Math.max(1, trackWidth - MOBILE_CART_HANDLE_SIZE - MOBILE_CART_HANDLE_INSET * 2);
    const progress = Math.min(1, Math.max(0, offset / maxTravel));
    mobileCartHandle.style.transform = `translateX(${offset}px) scale(${(1 + progress * 0.08).toFixed(3)})`;
    mobileCartHandle.style.backgroundPosition = `${Math.round(progress * 100)}% 50%`;
    mobileCartHandle.style.boxShadow = `0 ${(2 + progress * 6).toFixed(1)}px ${(8 + progress * 18).toFixed(1)}px rgba(31,23,54,${(0.16 + progress * 0.24).toFixed(2)})`;
    if (mobileCartContent) mobileCartContent.style.opacity = (1 - progress * 0.3).toFixed(2);
    const fillWidthPx = MOBILE_CART_HANDLE_INSET + offset + handleWidth / 2;
    const boundedFillWidthPx = Math.min(trackWidth, Math.max(0, fillWidthPx));
    track.style.setProperty('--dyo-cart-fill-width', boundedFillWidthPx.toFixed(1) + 'px');
  }

  async function confirmMobileCart() {
    if (mobileCartSliderBusy || !mobileCartSlider || mobileCartSlider.dataset.disabled === 'true') return;
    mobileCartSliderBusy = true;
    mobileCartHandle.disabled = true;
    if (mobileCartLabel) mobileCartLabel.textContent = 'Wird hinzugefügt …';

    const result = await addToCart();
    applyMobileCartOffset(0, true);

    if (result === true) {
      if (mobileCartLabel) mobileCartLabel.textContent = 'Hinzugefügt ✓';
      mobileCartSlider.classList.add('is-success');
      setTimeout(() => {
        mobileCartSlider.classList.remove('is-success');
        mobileCartSliderBusy = false;
        syncMobileCartSlider();
      }, 1200);
    } else if (result === false) {

      if (mobileCartLabel) mobileCartLabel.textContent = addBtn.textContent;
      setTimeout(() => {
        mobileCartSliderBusy = false;
        syncMobileCartSlider();
      }, 3000);
    } else {

      mobileCartSliderBusy = false;
      syncMobileCartSlider();
    }
  }

  (function setupMobileCartSlider() {
    if (!mobileCartSlider || !mobileCartHandle) return;

    let dragging = false;
    let pointerId = null;
    let startX = 0;
    let currentOffset = 0;
    let maxTravel = 0;

    function isReady() {
      return mobileCartSlider.dataset.disabled !== 'true' && !mobileCartSliderBusy;
    }

    function measure() {
      const trackWidth = mobileCartSlider.clientWidth;
      maxTravel = Math.max(1, trackWidth - MOBILE_CART_HANDLE_SIZE - MOBILE_CART_HANDLE_INSET * 2);
    }

    function setOffset(offset) {
      currentOffset = offset;
      applyMobileCartOffset(offset, false);
    }

    mobileCartHandle.addEventListener('pointerdown', (event) => {
      if (!isReady()) return;
      measure();
      dragging = true;
      pointerId = event.pointerId;
      startX = event.clientX;
      mobileCartSlider.classList.add('is-dragging');
      try { mobileCartHandle.setPointerCapture(pointerId); } catch (err) {}
    });

    mobileCartHandle.addEventListener('pointermove', (event) => {
      if (!dragging || event.pointerId !== pointerId) return;
      const delta = event.clientX - startX;
      setOffset(Math.min(maxTravel, Math.max(0, delta)));
    });

    function endDrag(event) {
      if (!dragging || event.pointerId !== pointerId) return;
      dragging = false;
      mobileCartSlider.classList.remove('is-dragging');
      try { mobileCartHandle.releasePointerCapture(pointerId); } catch (err) {}
      const progress = maxTravel > 0 ? currentOffset / maxTravel : 0;
      if (progress >= MOBILE_CART_THRESHOLD) {
        applyMobileCartOffset(maxTravel, true);
        confirmMobileCart();
      } else {
        setOffset(0);
        applyMobileCartOffset(0, true);
      }
    }

    mobileCartHandle.addEventListener('pointerup', endDrag);
    mobileCartHandle.addEventListener('pointercancel', (event) => {
      if (!dragging || event.pointerId !== pointerId) return;
      dragging = false;
      mobileCartSlider.classList.remove('is-dragging');
      setOffset(0);
      applyMobileCartOffset(0, true);
    });

    mobileCartHandle.addEventListener('keydown', (event) => {
      if (!isReady()) return;
      if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
        event.preventDefault();
        measure();
        applyMobileCartOffset(maxTravel, true);
        confirmMobileCart();
      }
    });
  })();

  const DIAG_ACTIONS = [
    ['perle', '[data-perle-id]'], ['designkugel', '[data-premium-kugel-id]'], ['spacer-typ', '[data-spacer-id]'],
    ['spacer-modus', '[data-spacer-mode]'], ['gap', '[data-gap]'], ['stein-entfernen', '[data-remove-slot]'],
    ['slot', '[data-slot]'], ['undo', '[data-undo]'], ['loeschen', '[data-clear]'], ['fuellen', '[data-fill-selected]'],
    ['muster', '[data-fill-pattern]'], ['groesse', '[data-wrist-id]'], ['verschluss', '[data-closure-option]'],
    ['entfernen-modus', '[data-delete-mode-toggle]'], ['warenkorb', '[data-add]']
  ];

  root.addEventListener('click', async (event) => {
    // Eine Ablehnungsmeldung gilt nur fuer die Aktion, die sie ausgeloest hat: beim naechsten Klick verschwindet sie
    // (eine erneut abgelehnte Aktion setzt sie sofort wieder).
    if (state.spacerNotice && !event.target.closest('[data-conflict-dismiss]')) {
      state.spacerNotice = null;
      renderConflictOverlay();
    }
    const diagHit = DIAG_ACTIONS.find(([, sel]) => event.target.closest(sel));
    if (diagHit) logDiag(diagHit[0]);
    const themeBtn = event.target.closest('[data-theme-btn]');
    if (themeBtn) {
      const theme = themeBtn.dataset.themeBtn === 'light' ? 'light' : 'dark';
      dyoApplyTheme(theme);
      try {
        window.localStorage.setItem(THEME_STORAGE_KEY, theme);
      } catch (err) {}
      return;
    }

    const stoneFilterBtn = event.target.closest('[data-stone-filter]');
    if (stoneFilterBtn) {
      state.stoneFilter = stoneFilterBtn.dataset.stoneFilter;
      root.querySelectorAll('[data-stone-filter]').forEach(btn => {
        btn.classList.toggle('is-active', btn === stoneFilterBtn);
      });
      renderPerlen();
      return;
    }

    const premiumColorFilterBtn = event.target.closest('[data-premium-color-filter]');
    if (premiumColorFilterBtn) {
      state.premiumColorFilter = premiumColorFilterBtn.dataset.premiumColorFilter;
      root.querySelectorAll('[data-premium-color-filter]').forEach(btn => {
        btn.classList.toggle('is-active', btn === premiumColorFilterBtn);
      });
      renderPremiumKugelStep();
      return;
    }

    const stoneTypeTabBtn = event.target.closest('[data-stone-type-tab]');
    if (stoneTypeTabBtn) {
      setStoneTypeTab(stoneTypeTabBtn.dataset.stoneTypeTab);
      return;
    }

    const selectionTabBtn = event.target.closest('[data-selection-tab]');
    if (selectionTabBtn) {
      switchSelectionTab(selectionTabBtn.dataset.selectionTab);
      return;
    }

    const wristBtn = event.target.closest('[data-wrist-id]');
    if (wristBtn) {
      const nextGroup = state.groessen.find(g => Number(g.id) === Number(wristBtn.dataset.wristId));
      if (!canSwitchSizeTo(nextGroup)) {
        renderConflictOverlay();
        return;
      }
      pushHistory();
      state.groesse = nextGroup;

      state.hiddenEmptySlots = 0;
      adjustSlotsToSize();
      renderGroessen();
      renderSlots();
      updatePriceAndSummary();
      updatePatternButtonLabel();
      renderSpacerStep();
      return;
    }

    const perleBtn = event.target.closest('[data-perle-id]');
    if (perleBtn) {
      setActiveSelection('naturalStone', Number(perleBtn.dataset.perleId));
      return;
    }

    const premiumKugelBtn = event.target.closest('[data-premium-kugel-id]');
    if (premiumKugelBtn) {
      setActiveSelection('premiumBead', Number(premiumKugelBtn.dataset.premiumKugelId));
      return;
    }

    const conflictDismissBtn = event.target.closest('[data-conflict-dismiss]');
    if (conflictDismissBtn) {
      state.spacerNotice = null;
      state.conflictOverlayDismissed = true;
      renderConflictOverlay();
      return;
    }

    const spacerCardBtn = event.target.closest('[data-spacer-id]');
    if (spacerCardBtn) {
      const spacerId = Number(spacerCardBtn.dataset.spacerId);
      if (!canSwitchSpacerTo(spacerId)) {
        renderConflictOverlay();
        return;
      }
      setActiveSelection('spacer', spacerId);
      state.activeSpacerId = spacerId;
      state.spacerNotice = null;
      if (state.spacerMode !== 'none') {
        adjustSlotsToSize();
      } else {
        resolvePendingIfPossible();
      }
      renderSlots();
      updatePriceAndSummary();
      return;
    }

    const closureOptionBtn = event.target.closest('[data-closure-option]');
    if (closureOptionBtn) {
      setClosureBead(closureOptionBtn.dataset.closureOption);
      return;
    }

    const closureTriggerBtn = event.target.closest('[data-closure-trigger]');
    if (closureTriggerBtn) {
      setClosureMenuOpen(closureTriggerBtn.getAttribute('aria-expanded') !== 'true');
      return;
    }

    const howtoToggleBtn = event.target.closest('[data-howto-toggle]');
    if (howtoToggleBtn) {
      const stepEl = howtoToggleBtn.closest('[data-howto-step]');
      if (stepEl) toggleHowtoStep(stepEl);
      return;
    }

    const spacerModeBtn = event.target.closest('[data-spacer-mode]');
    if (spacerModeBtn) {
      const targetMode = spacerModeBtn.dataset.spacerMode;
      if (targetMode === 'manual' && state.spacerMode === 'manual') {
        state.manualPreviewMode = !state.manualPreviewMode;
        renderSlots();
        renderSpacerStep();
        return;
      }
      const ok = setSpacerMode(targetMode);
      if (ok) {
        renderSlots();
        updatePriceAndSummary();
      } else {

        renderConflictOverlay();
      }
      renderSpacerStep();
      return;
    }

    const manualPreviewBtn = event.target.closest('[data-manual-preview-toggle]');
    if (manualPreviewBtn) {
      state.manualPreviewMode = !state.manualPreviewMode;
      renderSlots();
      renderSpacerStep();
      return;
    }

    const removeBtn = event.target.closest('[data-remove-slot]');
    if (removeBtn) {
      event.stopPropagation();
      const removeIndex = Number(removeBtn.dataset.removeSlot);
      if (state.slots[removeIndex]) {
        if (capacityReleaseNeeded()) {
          removeStoneAndReleaseCapacity(removeIndex);
        } else {
          removeStoneFromSlot(removeIndex);
        }
      }
      return;
    }

    const slotBtn = event.target.closest('[data-slot]');
    if (slotBtn) {
      const selected = getSelectedSlotContent();
      if (selected) setSlot(Number(slotBtn.dataset.slot), selected);
      return;
    }

    const gapBtn = event.target.closest('[data-gap]');
    if (gapBtn) {
      const gapIndex = parseGapId(gapBtn.dataset.gap);
      const alreadySet = state.spacerGaps.includes(gapIndex);
      let newGaps;
      if (alreadySet) {
        newGaps = state.spacerGaps.filter(g => g !== gapIndex);
      } else {
        if (!state.selectedSpacerId) return;
        newGaps = [...state.spacerGaps, gapIndex];
      }
      const ok = setSpacerGaps(newGaps);
      if (ok) {
        renderSlots();
        updatePriceAndSummary();
      } else {

        renderConflictOverlay();
      }
      renderSpacerStep();
      return;
    }

    const deleteModeBtn = event.target.closest('[data-delete-mode-toggle]');
    if (deleteModeBtn) {
      state.deleteMode = !state.deleteMode;

      slotRoot.classList.toggle('is-delete-mode', state.deleteMode);
      deleteModeBtn.classList.toggle('is-active', state.deleteMode);
      deleteModeBtn.setAttribute('aria-pressed', String(state.deleteMode));
      return;
    }

    if (event.target.closest('[data-undo]')) {
      if (state.history.length === 0) return;
      const snapshot = state.history.pop();

      const snapshotHiddenEmptySlots = snapshot.hiddenEmptySlots || 0;
      const structureUnchanged =
        !!state.groesse && !!snapshot.groesse &&
        state.groesse.key === snapshot.groesse.key &&
        state.spacerMode === snapshot.spacerMode &&
        state.hiddenEmptySlots === snapshotHiddenEmptySlots &&
        state.slots.length === snapshot.slots.length &&
        String(state.selectedSpacerId ?? '') === String(snapshot.selectedSpacerId ?? '') &&
        String(state.activeSpacerId ?? '') === String(snapshot.activeSpacerId ?? '') &&
        state.spacerGaps.length === snapshot.spacerGaps.length &&
        state.spacerGaps.every(g => snapshot.spacerGaps.includes(g));

      state.slots = snapshot.slots;
      state.groesse = snapshot.groesse;
      state.spacerGaps = snapshot.spacerGaps;
      state.freedSlots = snapshot.freedSlots || [];
      state.selectedSpacerId = snapshot.selectedSpacerId;
      state.activeSpacerId = snapshot.activeSpacerId;
      state.spacerMode = snapshot.spacerMode;

      state.hiddenEmptySlots = snapshotHiddenEmptySlots;
      state.spacerConflict = !!snapshot.spacerConflict;
      state.spacerConflictCount = snapshot.spacerConflictCount || 0;
      state.spacerConflictContext = snapshot.spacerConflictContext || null;
      state.spacerConflictCandidate = snapshot.spacerConflictCandidate || null;
      state.conflictOverlayDismissed = false;
      state.closureBead = CLOSURE_BEAD_OPTIONS[snapshot.closureBead] ? snapshot.closureBead : CLOSURE_BEAD_DEFAULT;
      renderGroessen();
      if (structureUnchanged) {
        updateSlotVisuals();
      } else {
        renderSlots();
      }
      syncClosureUi();
      updatePriceAndSummary();
      updatePatternButtonLabel();
      renderSpacerStep();
      return;
    }

    if (event.target.closest('[data-clear]')) {
      pushHistory();
      resetSlots();
      state.closureBead = CLOSURE_BEAD_DEFAULT;
      renderSlots();
      syncClosureUi();
      updatePriceAndSummary();
      renderSpacerStep();
      return;
    }

    if (event.target.closest('[data-fill-pattern]')) {
      if (!getSelectedSlotContent()) return;
      pushHistory();
      fillPatternSlots();

      if (state.hiddenEmptySlots > 0) {
        renderSlots();
      } else {
        updateSlotVisuals();
      }
      updatePriceAndSummary();
      return;
    }

    if (event.target.closest('[data-fill-selected]')) {
      const selected = getSelectedSlotContent();
      if (!selected) return;
      pushHistory();
      const visibleForFill = new Set(getVisibleStoneIndexes(state.slots.length));
      state.slots = state.slots.map((slot, i) => slot || (visibleForFill.has(i) ? selected : null));

      if (state.hiddenEmptySlots > 0) {
        renderSlots();
      } else {
        updateSlotVisuals();
      }
      updatePriceAndSummary();
      return;
    }

    if (event.target.closest('[data-add]')) {
      await addToCart();
      return;
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-closure-mobile]')) setClosureMenuOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const trigger = root.querySelector('[data-closure-trigger]');
    if (trigger && trigger.getAttribute('aria-expanded') === 'true') {
      setClosureMenuOpen(false);
      trigger.focus();
    }
  });

  let lastStageWidth = stage.clientWidth;
  let resizeRafId = null;
  window.addEventListener('resize', () => {
    if (resizeRafId !== null) return;
    resizeRafId = requestAnimationFrame(() => {
      resizeRafId = null;
      const currentWidth = stage.clientWidth;
      if (Math.abs(currentWidth - lastStageWidth) > 1) {
        lastStageWidth = currentWidth;
        renderSlots();
      }
    });
  });

  init();
})();
